/**
 * CsCanvas
 * Copyright 2015 YCS.
 * @author YCS
 */
/*
<2D Context globalCompositeOperation>
copy : 새 도형만 그리고 나머지는 모두 제거한다.
darker : 두 도형이 겹치는 부분에서는 두 색의 차이 값을 구하여 최종 색을 결정한다.
destination-atop : 기존에 있던 내용 중 오직 새 도형과 겹치는 부분만 보존된다. 새 도형은 기존 내용의 밑에 그려진다.
destination-in : 기존에 있던 내용 중 새 도형과 기존 캔버스 내용이 겹치는 부분만 보존된다. 나머지는 모두 투명하게 처리된다.
destination-out : 기존에 있던 내용 중 새 도형과 겹치지 않는 부분만 보존된다. 나머지는 모두 투명하게 처리된다.
destination-over : 새 도형은 기존 내용의 밑에 그려진다.
lighter : 두 도형이 겹치는 부분에서는 두 색 값의 합을 구하여 최종 색을 결정한다.
source-atop : 새로 그려질 도형 중 기존 내용과 겹치는 부분만 그려진다.
source-in : 새로 그려질 도형 중 새 도형과 기존 내용이 겹쳐지는 부분만 그려진다. 나머지는 모두 투명하게 처리된다.
source-out : 새로 그려질 도형 중 기존 내용과 겹치지 않는 부분만 그려진다.
source-over : 새 도형은 기존 내용 위에 그려진다. 기본값
xor : 겹쳐지는 부분의 도형은 모두 투명하게 그렇지 않은 부분은 정상적으로 그려진다.

<2D Context setTransform>
a	Scales the drawings horizontally
b	Skews the drawings horizontally
c	Skews the drawings vertically
d	Scales the drawings vertically
e	Moves the the drawings horizontally
f	Moves the the drawings vertically
 */
import $ from 'jquery'
import Hammer from 'hammerjs'


	if(!$){
		throw new Error('CsCanvas\'s JavaScript requires jQuery')
	}

	// var IS_TOUCH = device && (device.mobile() || device.tablet());
	let IS_TOUCH = typeof window !== 'undefined' &&
		(
			'ontouchstart' in window
			|| ('maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints > 0)
			|| (window.DocumentTouch && document instanceof window.DocumentTouch)
			// || (device && (device.mobile() || device.tablet()))
		);

	if(IS_TOUCH && !Hammer){
		console.warn('CsCanvas\'s JavaScript requires Hammer');
	}

	// TODO
	let requestAnimationFrame = (window.requestAnimationFrame || window.webkitRequestAnimationFrame)
		,cancelAnimationFrame = (window.cancelAnimationFrame || window.webkitCancelAnimationFrame);
	//var requestAnimationFrame = (window.requestIdleCallback || window.webkitRequestIdleCallback);
	// test
//	requestAnimationFrame = window.setTimeout;
//	cancelAnimationFrame = window.clearTimeout;

	if(!String.prototype.startsWith){
		String.prototype.startsWith = function(token){
			return this.indexOf(token) == 0;
		}
	}

	var VERSION = '0.2.6'
		,NS = 'CsCanvas'
		,NS_JQ_DATA = NS + '.data'
		,NS_JQ_EVENT = '.' + NS;

	var METHODS = {
		// 초기화
		init: function(options){
			var $this = this;

			// init 이 이미 되어있는 경우 destroy
			METHODS.destroy.call($this);

			$this.each(function(i, o){
				var $this = $(this);
			});

			// 기초 data setting
			if(!Data($this)){
				Data($this, new CsCanvas($this, options));
			}

			//console.log('#CsCanvas init');
		},
		// destroy
		destroy: function(){
			this.off(NS_JQ_EVENT);
		},
//		redraw: function(){
//			var csCanvas = Data(this);
//			csCanvas.redraw();
//		},
		csCanvas: function(){
			return Data(this);
		},

		methods: function(){
			var list = [];
			for(var key in METHODS){
				if(key != 'methods'){
					list.push(key);
				}
			}
			return list;
		}
	};

	/**
	 * 객체에 data 를 setting 한다.
	 * data parameter ? set : get
	 * @param $o
	 * @param data
	 */
	const Data = function($o, data){
		if(data === undefined){
			return $o.data(NS_JQ_DATA);
		}
		$o.data(NS_JQ_DATA, data);
	};

	/**
	 * Event regi
	 * @param $o
	 * @param eventType
	 * @param func
	 */
	const On = function($o, eventType, func){
		let list = eventType.split(' ');
		list.forEach(type => {
			$o.on(type + NS_JQ_EVENT, func);
		});
		return $o;
	};

	/**
	 * Event trigger
	 * @param $o
	 * @param data
	 */
	var Trigger = function($o, data){
		//data.type += NS_JQ_EVENT;
		//$o.trigger(data);
		$o.triggerHandler(data);
		return $o;
	};

	var OptionsInterface = {
		css: {
			cursor: 'default',
			backgroundColor: '#ffffff'
		},
		autoResize: true,
		minZoom: 0.3,
		maxZoom: 2,
		rightClickDisable: true,
		redraw: true,
		toolkit: 'Pencil',
		toolkitStyle: {},
		smoothValue: 0,
		laserPointerTruncate: 0,
		pointerPreview: true,
	}

	/**
	 * CsCanvas Constructor
	 */
	const CsCanvas = function($base, options){
		const THIS = this;

		$base = $base instanceof $ ? $base : $($base);
		options = $.extend( true, $.extend({}, OptionsInterface), options||{} );

		let window = options.window = options.window
		|| ($base[0] && $base[0].ownerDocument && $base[0].ownerDocument.defaultView)
		|| window;

		let document = options.document = options.document
		|| $base[0].ownerDocument;

		this.eventMap = new Map();

		this.getBase = function(){
			return $base;
		};
		this.getOptions = function(){
			return options;
		};

		var baseSize = {
			width: $base[0].clientWidth,
			height: $base[0].clientHeight
		}

//		$base.css('position', 'relative');
		var $canvasLayer = $('<div><div></div></div>').appendTo($base);
		$canvasLayer.css({
			position: 'relative',
			fontSize: '10px',
			fontSize: '10px',
			'touch-action': 'none'
		});
		$canvasLayer.find('div').css({
			position: 'absolute',
			left: '0px',
			top: '0px'
		});
		this.getCanvasLayer = function(){
			return $canvasLayer;
		};

		var setBaseStyle = function(canvas){
			var $canvas = $(canvas)
			$canvas.attr(baseSize);
			$canvas.css({
				//width: '100%',
				//height: '100%',
				position: 'absolute',
				left: '0px',
				right: '0px',
				top: '0px',
				bottom: '0px',
				//cursor: 'default',
				//border: '1px solid red',
				backgroundColor: ''
			});
		};

		var canvasSeq = 0;

		$base.on('selectstart select', function(e){
			e.preventDefault();
			e.stopPropagation();
			return false;
		});
		$base.attr('draggable', 'false');
		if($base.attr('id') === ''){
			$base.attr('id', '_csc_base_'+(new Date().getTime()));
		}

		var createCanvas = function(isAppend){
			var canvas = null;
			if(isAppend==false){
				canvas = $('<canvas></canvas>');
			}else{
				canvas = $('<canvas></canvas>').appendTo($canvasLayer.find('div'));
			}

			canvas
			.attr({
				id: '_csc_'+(new Date().getTime())+'_'+(canvasSeq++),
				draggable: false
			})
			.css({
				webkitUserSelect: 'none',
				// 'touch-action': 'none',
				font: $canvasLayer.css('font')
			});

			var conetext = canvas[0].getContext("2d");

			setBaseStyle(canvas);

			return {
				canvas: canvas[0],
				context: conetext
			};
		};

		var bgImg = null;
		this.removeBackgroundImage = function(){
			bgImg = null;
		}
		this.setBackgroundImage = async function(img, callback){
			if(!callback){
				callback = function(){};
			}

			if(!img){
				callback(false, 'img is null');
				return Promise.reject('img is null');
			}else if(typeof(img) == 'string'){
				if(!img.trim()){
					callback(false, 'img is empty');
					return Promise.reject('img is empty');
				}
				return new Promise((resolve, reject) => {
					bgImg = new Image();
					bgImg.onload = function(){
						THIS.redraw();
						callback.call(THIS, true, bgImg);
						resolve(bgImg);
					}
					bgImg.onerror = function(e){
						callback.call(THIS, false, bgImg, e);
						reject(e);
					}
					bgImg.src = img;
				});
			}else if(img instanceof HTMLImageElement){
				bgImg = img;
				THIS.redraw();
				callback.call(THIS, true, bgImg);
				return bgImg;
			}
		};
		this.getBackgroundImage = function(){
			return bgImg;
		};
		this.setBackgroundColor = function(color){
			this.getBgCanvas().style.backgroundColor = color;
		};

		// bg canvas S
		var bgCanvas = createCanvas();
		$(bgCanvas.canvas).css(options.css);
		this.getBgCanvas = function(){
			return bgCanvas.canvas;
		};
		this.getBgContext = function(){
			return bgCanvas.context;
		};
		// bg canvas E

		// draw canvas S
		// 실제 보여질 판서 캔버스
		var drawViewCanvas = createCanvas();
		this.getDrawViewCanvas = function(){
			return drawViewCanvas.canvas;
		};
		this.getDrawViewContext = function(){
			return drawViewCanvas.context;
		};
		this.cloneDrawViewContext = function(){
			return drawViewCanvas.canvas.cloneNode().getContext('2d');
		};
		// hidden 상태에서 그려질 판서 캔버스
		var drawCanvas = createCanvas(false);
		this.getDrawCanvas = function(){
			return drawCanvas.canvas;
		};
		this.getDrawContext = function(){
			return drawCanvas.context;
		};
		// 한 작업(mousedown-move-up)만 draw 할 캔버스
		var drawTempCanvas = createCanvas(false);
		this.getDrawTempCanvas = function(){
			return drawTempCanvas.canvas;
		};
		this.getDrawTempContext = function(){
			return drawTempCanvas.context;
		};
		this.cloneDrawTempContext = function(){
			return drawTempCanvas.canvas.cloneNode().getContext('2d');
		}
		// draw canvas E

		// pointer canvas S
		// pointer map
		this.pointerMap = new Map();//{};
		// timer object
		this.drawPointerTimer = {};
		var pointerCanvas = createCanvas();
		this.getPointerCanvas = function(){
			return pointerCanvas.canvas;
		};
		this.getPointerContext = function(){
			return pointerCanvas.context;
		};
		// pointer canvas E

		// temp canvas S
		// 사용자 이벤트 잡는 캔버스
		var tempCanvas = createCanvas();
		tempCanvas.canvas.style.pointerEvents = 'auto';
		this.getTempCanvas = function(){
			return tempCanvas.canvas;
		};
		this.getTempContext = function(){
			return tempCanvas.context;
		};
		if(options.rightClickDisable){
			$(tempCanvas.canvas).on('contextmenu', function(){
				return false;
			});
		}
		// temp canvas E

		// set toolkits
		this.toolkits = {};
		$.each(Toolkit.cloneToolkits(), function(type, toolkit){
			toolkit.csCanvas = THIS;
			THIS.toolkits[type] = toolkit;
			if(toolkit.init){
				toolkit.init();
			}

			if(options.useWheel === false){
				toolkit.wheel = function(){};
			}
		});
		if(options.unuseToolkit){
			options.unuseToolkit.forEach(function(type){
				delete THIS.toolkits[type];
			});
		}

		// set events S -----------------------------------------------------------
		var $tempCavnas = $(tempCanvas.canvas);

//		window.__cs_cvs_cnt = 0;
		var unchkPointerEvent = true;
		// 		window.__test_arr = [];
		let passive = false;
		var executeEvent = function(event){
			//(event.originalEvent || event).preventDefault();
			//event.preventDefault();
			//event.stopPropagation();

			var toolkit = THIS.currentToolkit;
			if(!toolkit){
				return;
			}

			// console.log('# cvs _', event.type);
			// window.__test_arr.push(event);
			if(event.type === 'pointerdown'){
				let pointerTypeEventObj = {
					mouse: ['mousedown', 'mousemove', 'mouseup'],
					pen: ['', 'pointermove', 'pointerup'],
					// pen pointer event 를 사용할 경우 애플 펜슬 확대 축소 등의 이벤트가 발생된다. 좌표는 touch event 를 사용함.
					// pen: ['touchmove', 'touchend'],
					touch: ['touchstart', 'touchmove', 'touchend'],
				}
				const pointerType = event.pointerType || 'mouse';
				let pointerTypeEvents = [
					pointerTypeEventObj[pointerType]
				];
				if(pointerType === 'pen'){
					pointerTypeEvents.push(pointerTypeEventObj.touch);
				}
				// console.log('# pointer type : type[%s]', pointerType);

				// document.body.style.___pointerEvents = document.body.style.pointerEvents;
				// document.body.style.pointerEvents = 'none';
				const target = pointerType === 'mouse' ? window : $tempCavnas[0];
				// const target = $tempCavnas[0];
				window.documentOnSelectStart = document.onselectstart;
				document.onselectstart = function () {
					return false;
				};

				$tempCavnas[0].removeEventListener('mousemove', executeEvent);

				pointerTypeEvents.forEach(ptEvents => {
					if(!ptEvents) return;
					$tempCavnas[0].removeEventListener(ptEvents[1], executeEvent);

					passive = false;
					if(ptEvents[0]){
						target.addEventListener(ptEvents[0], executeEvent, {once: true, passive});
					}
					target.addEventListener(ptEvents[1], executeEvent, {passive});
					target.addEventListener(ptEvents[2], function (event) {
						// document.body.style.pointerEvents = document.body.style.___pointerEvents;
						document.onselectstart = window.documentOnSelectStart;
						delete window.documentOnSelectStart;

						target.removeEventListener('mousemove', executeEvent);
						if(ptEvents[0]){
							target.removeEventListener(ptEvents[0], executeEvent);
						}
						target.removeEventListener(ptEvents[1], executeEvent);

						executeEvent(event);
						// $tempCavnas[0].addEventListener('mousemove', executeEvent, {passive});
					}, {once: true});
				});
				return;
			}

			switch(event.type) {
				// case 'mousedown':
				case 'touchstart':
				case 'pointerdown':
					if(document.body.style__pe_evt === undefined){
						document.body.style__pe_evt = document.body.style.pointerEvents;
						document.body.style.pointerEvents = 'none';
					}
					break;
				case 'mouseup':
				case 'touchend':
				case 'pointerup':
					if(document.body.style__pe_evt !== undefined){
						document.body.style.pointerEvents = document.body.style__pe_evt;
						delete document.body.style__pe_evt;
					}
					break;
			}

			switch(event.type){
				case 'mousedown':
				case 'touchstart':
				case 'pointerdown':
					break;
				case 'mouseup':
				case 'touchend':
				case 'pointerup':
					break;
				case 'mousemove':
					if(!passive){
						event.preventDefault();
					}
					break;
				case 'touchmove':
				case 'pointermove':
				case 'pinchstart':
				case 'pinchmove':
					if(!passive){
						event.preventDefault();
					}
					break;
				default:
					event.preventDefault();
					event.stopPropagation();
					break;
			}

			toolkit[event.type](event, THIS);
		}

		// mouse touch
		$.each(ToolkitInterface, function(key, value){
			if(key.indexOf('mouse')!==0
					&& key.indexOf('touch')!==0
					&& key.indexOf('pointer')!==0
					&& key.indexOf('click')!==0
					&& key.indexOf('wheel')!==0){
				return;
			}

			let cvs = window;

			switch (key) {
				case 'mousedown':
				case 'touchstart':
					return;
				case 'mouseover':
				case 'mousemove':
				case 'pointermove':
				case 'pointerup':
				case 'touchmove':
				case 'touchend':
					return;
				case 'click':
				case 'mousedown':
				case 'mouseout':
					cvs = $tempCavnas[0];
					break;
				// return;
				case 'wheel':
					cvs = $base[0];
					break;
				case 'mouseup':
					return;
			}

			if(key.indexOf('touch') === 0 || key.indexOf('pointer') === 0){
				if(!IS_TOUCH){
					//return;
				}
				cvs = $tempCavnas[0];
			}

			// console.log('# add event', key, cvs);
			cvs.addEventListener(key, executeEvent, false);
		});
		// mobile pinch
		if(IS_TOUCH){
			if(Hammer){
				var mc = new Hammer.Manager($base[0]);
				//mc.add(new Hammer.Pan({ threshold: 0, pointers: 0 }));
				mc.add(new Hammer.Pinch({ threshold: 0 })/*.recognizeWith([mc.get('pan')])*/);
				mc.on('pinchstart pinchmove', function(event){
					if(!event.stopPropagation){
						event.stopPropagation = function(){};
					}
					// console.log('## pinch event :', event.type, event);
					executeEvent(event);
				});
			}
		}
		// set events E -----------------------------------------------------------

		// metrix init
		if(!options.metrix){
			options.metrix = {};
		}
		this.metrix = $.extend({
			ratio: 1, // 배율
			autoRatio: true,
			holdRatio: false,
			//ratio_window: 1,
			zoom: 1, // zoom
			moveX: 0,
			moveY: 0,
			baseWidth: 0,
			baseHeight: 0,
			canvasWidth: 0,
			canvasHeight: 0,
			oriWidth: 0,
			oriHeight: 0
		}, options.metrix);

		var initMetrix = $.extend(true, {}, this.metrix);
		this.reset = function(){
			initMetrix.oriWidth = THIS.metrix.oriWidth;
			initMetrix.oriHeight = THIS.metrix.oriHeight;

			THIS.metrix = initMetrix;

			THIS.clearCanvas();
		}

		// init

		var sizeMonitor;
		if(options.autoResize == true){

			// window resize
			var resizeTimer;
			On($(window), 'resize orientationchange', function(){
				clearTimeout(resizeTimer);

				resizeTimer = setTimeout(function(){
					if(THIS.metrix.baseWidth != $base[0].clientWidth){
						THIS.redraw.call(THIS);
					}
				}, 100);
//				console.error('',
//						THIS.metrix.baseWidth,'/', THIS.metrix.baseHeight,
//						'__',
//						$base[0].clientWidth)
//				);
				if(THIS.metrix.baseWidth != $base[0].clientWidth){
					THIS.redraw.call(THIS);
				}
			});
			// size monitoring
			//sizeMonitor = window.setInterval(resizeCsCanvas, 1000);
		}

		// lazy init
		var toolkit = THIS.toolkits[options.toolkit] || THIS.toolkits.Pencil;
		$.extend(true, toolkit.style, options.toolkitStyle);
		THIS.setToolkit(toolkit, false);
		// setTimeout(function(){
		// 	THIS.setToolkit(toolkit);
		// }, 10);

		this.size($base[0].clientWidth);
	}; // CsCanvas Constructor

	// Util S ------------------------------------------------------
	CsCanvas.Util = {};

	$.extend(CsCanvas.Util, {
		getPoint: function(event, rect, data){
			var x, y;
			var list;
			if(
				event.type.startsWith('mouse')
				|| event.type.startsWith('pointer')
				|| event.type.startsWith('wheel')
			){
				if(rect){
					//var rect = baseEl.getBoundingClientRect();
					x = event.clientX - rect.left;
					y = event.clientY - rect.top;
				}else{
					x = typeof event.offsetX !== 'undefined' ? parseInt(event.offsetX) : parseInt(event.layerX);
					y = typeof event.offsetY !== 'undefined' ? parseInt(event.offsetY) : parseInt(event.layerY);
				}
				//ttt(event.target, x,y, event.clientX, event.clientY)
			}else{
				// touch
				event = event.originalEvent || event;
				const touches = event.changedTouches || event.pointers || event.touches;

				//var offset = $(event.target).offset();
				if(!rect){
					rect = event.target.getBoundingClientRect();
				}

				list = [];
				for(var i=0, len=touches.length; i<len; i++){
//					var px = touches[i].pageX - offset.left + document.body.scrollLeft;
//					var py = touches[i].pageY - offset.top + document.body.scrollTop;
// 					var px = touches[i].pageX - rect.left + document.body.scrollLeft;
// 					var py = touches[i].pageY - rect.top + document.body.scrollTop;
// 					let px = touches[i].clientX - rect.left + document.body.scrollLeft;
// 					let py = touches[i].clientY - rect.top + document.body.scrollTop;
						var px = touches[i].clientX
							- rect.left
							+ ((data && data.scrollLeft) || document.body.scrollLeft);
						var py = touches[i].clientY
							- rect.top
							+ ((data && data.scrollTop) || document.body.scrollTop);
//					var px = touches[i].clientX;
//					var py = touches[i].clientY;

					if(i==0){
						x = px;
						y = py;
					}
					list.push( {x:px, y:py} );
				}
			}
			return {x:x, y:y, list: list};
		},
		getRatioPoint: function(x, y, metrix){
			var r = metrix.ratio * metrix.zoom;
			x = (x - metrix.moveX) / r;
			y = (y - metrix.moveY) / r;
			return {x:parseFloat(x.toFixed(2)), y:parseFloat(y.toFixed(2))};
		},
		getReverseRatioPoint: function(x, y, metrix){
			var r = metrix.ratio * metrix.zoom;
			x = x * r + metrix.moveX;//(x + metrix.moveX) * r;
			y = y * r + metrix.moveY;//(y + metrix.moveY) * r;
			return {x:parseFloat(x.toFixed(2)), y:parseFloat(y.toFixed(2))};
		},
		drawPoints: function(ctx, points, clear){
			const len = points.length;
			// console.log('@len :', len)
			if(len === 2){
				ctx.beginPath();
				ctx.arc(points[0], points[1], ctx.lineWidth / 2, 0, Math.PI * 2, !0);
				ctx.fill();
				ctx.closePath();
				return;
			}else if(len < 5){
				ctx.beginPath();
				ctx.moveTo(points[0], points[1]);
				ctx.lineTo(points[2], points[3]);
				ctx.closePath();
				ctx.stroke();
				return;
			}

			if(clear !== false){
				//ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
				CsCanvas.Util.clearCanvas(ctx);
			}

			ctx.beginPath();
			ctx.moveTo(points[0], points[1]);

			let i=2;

//			ctx.closePath();
//			ctx.stroke();
//			for(var len=points.length; i<len; i+=2){
//				ctx.beginPath();
//				ctx.moveTo(points[i-2], points[i-1]);
//				ctx.lineTo(points[i], points[i+1]);
//				ctx.closePath();
//				ctx.stroke();
//			}

//			for(var len=points.length-4; i<len; i+=2){
//				var midX = (points[i] + points[i + 2]) / 2;
//				var midY = (points[i+1] + points[i + 3]) / 2;
//				
//				ctx.lineTo(points[i], points[i+1]);
//				ctx.lineTo(midX, midY);
//			}

			for(;i<len; i+=2){
				let midX = (points[i] + points[i + 2]) / 2;
				let midY = (points[i+1] + points[i + 3]) / 2;

				ctx.quadraticCurveTo(points[i], points[i+1], midX, midY);
			}
			//ctx.lineTo(points[i], points[i+1]);

//			for(var len=points.length-4; i<len; i+=4){
//				ctx.quadraticCurveTo(points[i], points[i+1], points[i+2], points[i+3]);
//			}
//			for(var len=points.length-4; i<len; i+=6){
//				ctx.bezierCurveTo(
//						points[i], points[i+1],
//						points[i+2], points[i+3],
//						points[i+4], points[i+5]
//				);
//			}

//			i = points.length - 2 - 2;
//			if(i){
//				ctx.quadraticCurveTo(
//						points[i],
//						points[i+1],
//						points[i + 2],
//						points[i + 3]
//				);
//			}
			ctx.stroke();

//			ctx.beginPath();
//			
//			var x = points[0].x, y = points[0].y;
//			ctx.moveTo(x, y);
//			
//			var cp = function(p1, p2){
//				return (p1 + p2) / 2;
//			}
//			
//			x = cp(x, points[1].x);
//			y = cp(y, points[1].y);
//			
//			var i=1;
//			for(var len=points.length-2; i<len; i+=2){
//				try{
//					var midX = cp(x, points[i].x);
//					var midY = cp(y, points[i].y);
//					
////					ctx.quadraticCurveTo(x, y, midX, midY);
////					x = midX;
////					y = midY;
//
//					var mid2X = cp(midX, points[i+1].x);
//					var mid2Y = cp(midY, points[i+1].y);
//
//					ctx.bezierCurveTo(x,y, midX,midY, mid2X, mid2Y);
//					
//					x = points[i+1].x;
//					y = points[i+1].y;
//				}catch(e){}
//			}
//			
//			i = points.length - 1 - 1;
//			ctx.quadraticCurveTo(
//					points[i].x,
//					points[i].y,
//					points[i + 1].x,
//					points[i + 1].y
//			);
//			ctx.stroke();
		},
		drawLines: function(ctx, points, clear){
			if(!points) return;
			if(points.length > 0 && Array.isArray(points[0])){
				for(let i=0, len=points.length; i<len; i++){
					this.drawLines(ctx, points[i], i===0);
				}
				return;
			}

			if(points.length < 4){
				return;
			}

			if(clear !== false){
				CsCanvas.Util.clearCanvas(ctx);
			}

			ctx.beginPath();
			ctx.moveTo(points[0], points[1]);

			for(var i=2, len=points.length; i<len; i+=2){
				ctx.lineTo(points[i], points[i+1]);
			}
			ctx.stroke();
		},
		drawArc: function(ctx, points, clear){
			if(clear !== false){
				CsCanvas.Util.clearCanvas(ctx);
			}

			var radiusX = (points[2] - points[0]) * 0.5,
				radiusY = (points[3] - points[1]) * 0.5,
				centerX = points[0] + radiusX,
				centerY = points[1] + radiusY,
				step = 0.01,
				a = step,
				pi2 = Math.PI * 2 - step;

			ctx.beginPath();
			ctx.moveTo(centerX + radiusX * Math.cos(0),
				centerY + radiusY * Math.sin(0));

			for(; a < pi2; a += step) {
				ctx.lineTo(centerX + radiusX * Math.cos(a),
					centerY + radiusY * Math.sin(a));
			}

			ctx.closePath();
			ctx.stroke();
		},
		clearCanvas: function(ctx){
			//ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
			ctx.clearRect(0, 0, Math.max(ctx.canvas.width, 9999), Math.max(ctx.canvas.height, 9999));
			return this;
		},
		getRandomColor: function(){
//			var letters = '0123456789ABCDEF'.split('');
//			var color = '#';
//			for (var i = 0; i < 6; i++ ) {
//				color += letters[Math.floor(Math.random() * 16)];
//			}
//			return color;
			return '#'+(Math.random()*0xFFFFFF<<0).toString(16);
		}
	});

	$.extend(CsCanvas.Util, {
		setContextStyle: function(ctx, style, metrix){
			var fillStyle;
			$.each(style, function(key, value){
				if(key=='strokeStyle'){
					if(value && value.substring(0, 1)=='#'){
						value = CsCanvas.Util.color.hexToRgba(value, style.opacity);
					}
					if(!fillStyle){
						ctx.fillStyle = value;
					}
				}else if(key=='opacity'){
					return;
				}else if(key=='fillStyle'){
					fillStyle = true;
				}

				if(metrix){
					if(key=='lineWidth'){
						value = value * metrix.ratio * metrix.zoom;
					}
				}

				ctx[key] = value;
			});
		},
		color: {
			/*
			 * hex(#000000) -> rgba(xxx, xxx, xxx, x)
			 */
			hexToRgba: function(hex, opacity){
				if(hex.startsWith('rgba')){
					return hex;
				}

				hex = hex.replace('#','');
				var r = parseInt(hex.substring(0,2), 16);
				var g = parseInt(hex.substring(2,4), 16);
				var b = parseInt(hex.substring(4,6), 16);

				if(opacity==null) opacity = 100;
				var result = 'rgba('+r+','+g+','+b+','+opacity+')';
				return result;
			},
			/*
			 * rgba(xxx, xxx, xxx, x) -> hex(#000000)
			 */
			rgbaToHex: function(rgba){
				if(!rgba){
					return {hex:'#000000', opacity: 100};
				}else if(rgba.startsWith('#')){
					return {hex:rgba, opacity: 100};
				}
				rgba = rgba.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+(\.?\d*))[\s+]?/i);

				var hex, opacity;
				if(rgba && (rgba.length === 5 || rgba.length === 6)){
					hex = '#'
					+ ('0' + parseInt(rgba[1], 10).toString(16)).slice(-2)
					+ ('0' + parseInt(rgba[2], 10).toString(16)).slice(-2)
					+ ('0' + parseInt(rgba[3], 10).toString(16)).slice(-2);

					opacity = parseFloat(rgba[4]) * 100;
				}
				return {hex:hex, opacity: opacity};
			}
		}
	});

	// Util E ------------------------------------------------------

	$.extend(CsCanvas.prototype, {
		version: function(){
			return VERSION;
		},
		isEnabled: function(){
			return this.getTempCanvas().offsetWidth > 0;
		},
		disable: function(){
			//this.getCanvasLayer().hide();
			$(this.getTempCanvas()).hide();
		},
		enable: function(){
			//this.getCanvasLayer().show();
			$(this.getTempCanvas()).show();
		},
		setMetrix: function(metrix){
			if(!metrix){
				return;
			}
			$.extend(this.metrix, metrix);
			this.redraw(true);
		},
		size: function(width, height){
			if(width && width > 0 && height && height > 0){
				this.metrix.oriWidth = width;
				this.metrix.oriHeight = height;
				this.redraw(true);
			}

			//this.getBase().trigger({
			this.trigger({
				type: 'changesize',
				csCanvas: this,
				width: this.metrix.oriWidth,
				height: this.metrix.oriHeight
			});
			return {width: this.metrix.oriWidth, height: this.metrix.oriHeight};
		},
		clearCanvas: function(pubEvent){
			let THIS = this;
			CsCanvas.Util.clearCanvas(THIS.getDrawTempContext());
			CsCanvas.Util.clearCanvas(THIS.getDrawContext());
			THIS.redraw(true);

			if(pubEvent!==false){
				//THIS.getBase().trigger({
				THIS.trigger({
					type: 'clear',
					csCanvas: THIS
				});
			}
			return this;
		},
		changeMirrorPoint: function(point){
			var THIS = this;
			var x = THIS.metrix.oriWidth - point.x;
			//var y = THIS.metrix.oriHeight - point.y;
			return {x:x, y:point.y};
		},
		zoom: function(zoom, currentPoint){
			if(!zoom || zoom <= 0){
				return this.metrix.zoom;
			}

			let change = this.metrix.zoom != zoom;
			if(!change){
				return this.metrix.zoom;
			}

			let hr = this.metrix.holdRatio;
			this.metrix.holdRatio = true;
			try{
				if(currentPoint === 'center'){
					currentPoint = {
						x: $(this.getTempCanvas())[0].clientWidth / 2,
						y: $(this.getTempCanvas())[0].clientHeight / 2
					}
				}

				if(currentPoint){
					// currentPoint 을 중심으로 확대.
					let metrix = this.metrix;
					let oldZoom = metrix.zoom;

					// set zoom
					zoom = this.zoom(zoom);

					// 이동된 배율
					let movePointRatio = zoom / oldZoom;

					if(movePointRatio !== 1){
						let x = (metrix.moveX * movePointRatio) - ((currentPoint.x * movePointRatio) - currentPoint.x);
						let y = (metrix.moveY * movePointRatio) - ((currentPoint.y * movePointRatio) - currentPoint.y);
						this.move(x, y);
					}
				}else{
					let metrix = this.metrix;
					let oldZoom = metrix.zoom;
					let r = metrix.ratio * zoom;

					metrix.zoom = Math.max(zoom, this.getOptions().minZoom);
					metrix.zoom = Math.min(metrix.zoom, this.getOptions().maxZoom);
					this.redraw(true, true);
				}
				return this.metrix.zoom;
			}finally{
				this.metrix.holdRatio = hr;
			}
		},
		zoomFit: function(){
			var metrix = this.metrix;
			metrix.autoRatio = true;
			metrix.zoom = 1;
			this.redraw(true);
		},
		zoomOri: function(){
			var metrix = this.metrix;
			metrix.autoRatio = false;
			metrix.ratio = 1;
			metrix.zoom = 1;
			this.redraw(true);
		},
		/*
		 * 이동 가능한 상태인지 여부
		 */
		isMoveEnable: function(){
			var metrix = this.metrix;
			var ratio = metrix.ratio * metrix.zoom;
			if(metrix.oriWidth * ratio > metrix.canvasWidth){
				return true;
			}else if(metrix.oriHeight * ratio > metrix.canvasHeight){
				return true;
			}
			return false;
		},
		/*
		 * canvas 이동
		 */
		move: function(x, y){
			var hr = this.metrix.holdRatio;
			this.metrix.holdRatio = true;
			try{
				if(this.isMoveEnable()==false){
					//console.warn('[CsCanvas] zoom is 1');
					return {x: this.metrix.moveX, y: this.metrix.moveY};
				}
				if(isNaN(x)==false && isNaN(y)==false){
					this.metrix.moveX = x;
					this.metrix.moveY = y;
					this.redraw(true, true);
					return {x: this.metrix.moveX, y: this.metrix.moveY};
				}else{
					return {x: this.metrix.moveX, y: this.metrix.moveY};
				}
			}finally{
				this.metrix.holdRatio = hr;
			}
		},
		drawContext: function(ctx, globalCompositeOperation){
			var ctxDraw = this.getDrawContext();
			ctxDraw.save();
			try{
				ctxDraw.globalCompositeOperation = globalCompositeOperation || 'source-over';
				ctxDraw.drawImage(ctx.canvas, 0, 0);
				this.redraw();
			}finally{
				ctxDraw.restore();
			}
		},
		drawPoints: function(pointList, style){
			var ctx = this.getDrawTempContext();

			//ctx.save();

			// set style
			CsCanvas.Util.setContextStyle(ctx, style);

			// draw points
			CsCanvas.Util.drawPoints(ctx, pointList);

			// draw canvas
			this.getDrawContext().drawImage(ctx.canvas, 0, 0);

			// redraw
			this.redraw();

			CsCanvas.Util.clearCanvas(ctx);

			//ctx.restore();
		},
		/*
		 * 재구성
		 */
		redraw: function(forceResize, async){
			var options = this.getOptions();
			if(options.redraw != true){
				return;
			}

			var $base = this.getBase();

//			if(options.redrawAsync && async !== false){
			if(async === true){
				cancelAnimationFrame($base._ani_no);
				$base._ani_no = requestAnimationFrame(this.redraw.bind(this, forceResize, false));
//				clearTimeout($base._ani_no);
//				$base._ani_no = setTimeout(this.redraw.bind(this, forceResize, false), 10);
				return;
			}

			var width = $base[0].clientWidth;//$base[0].clientWidth;
			var height = $base[0].clientHeight;//$base[0].clientHeight;

			var metrix = this.metrix;

			var oriWidth = metrix.oriWidth = metrix.oriWidth || width;
			var oriHeight = metrix.oriHeight = metrix.oriHeight || height;
			if(oriWidth === 0 || oriHeight === 0) return;

			metrix.zoom = Math.max(metrix.zoom, this.getOptions().minZoom);
			metrix.zoom = Math.min(metrix.zoom, this.getOptions().maxZoom);

			// 변화있을 경우 canvas resize
			if(forceResize || metrix.baseWidth != width || metrix.baseHeight != height){
				metrix.baseWidth = width;
				metrix.baseHeight = height;

				// 배율 계산
				if(!metrix.holdRatio && metrix.autoRatio){
					metrix.ratio = Math.min(width / oriWidth, height / oriHeight);

					// 배율 크기설정
//					metrix.canvasWidth = metrix.oriWidth * metrix.ratio * (metrix.zoom < 1 ? metrix.zoom : 1);
//					metrix.canvasHeight = metrix.oriHeight * metrix.ratio * (metrix.zoom < 1 ? metrix.zoom : 1);
				}

				// TODO
				// 배율 크기설정
				metrix.canvasWidth = oriWidth * metrix.ratio * (metrix.zoom);
				metrix.canvasHeight = oriHeight * metrix.ratio * (metrix.zoom);
				//console.debug("resize ratio : ", metrix.ratio);


				metrix.canvasWidth = Math.min(metrix.canvasWidth, width);
				metrix.canvasHeight = Math.min(metrix.canvasHeight, height);

				// resize child canvas
//				$base.find('canvas').attr({
//					width: metrix.canvasWidth,
//					height: metrix.canvasHeight
//				});
				var cvsList = $base[0].getElementsByTagName('canvas');
				for(var ci=0, cvsLen=cvsList.length; ci<cvsLen; ci++){
					cvsList[ci].setAttribute('width', metrix.canvasWidth);
					cvsList[ci].setAttribute('height', metrix.canvasHeight);
				}

				// 정렬
				this.getCanvasLayer().css({
//					width: metrix.canvasWidth + 'px',
//					height: metrix.canvasHeight + 'px',
					width: '100%',
					height: 'calc(100% - '+(height - metrix.canvasHeight)+'px)',
					marginLeft: (width - metrix.canvasWidth) / 2,
					marginTop: (height - metrix.canvasHeight) / 2
				});
			}

			var ctx = this.getBgContext();
			var ctxDrawView = this.getDrawViewContext();
			var ctxDraw = this.getDrawContext();
			var bgImg = this.getBackgroundImage();
			var se = true, qt = 'medium';
			function _sctx(_ctx){
				_ctx.mozImageSmoothingEnabled = _ctx.webkitImageSmoothingEnabled = _ctx.msImageSmoothingEnabled = se;
				_ctx.imageSmoothingEnabled = se;
				_ctx.imageSmoothingQuality = qt;
			}

			if(ctxDraw.canvas.width != oriWidth || ctxDraw.canvas.height != oriHeight){
				var cn = ctxDraw.canvas.cloneNode();
				var cnCtx = cn.getContext("2d");
				try{
					_sctx(cnCtx);
					cnCtx.drawImage(ctxDraw.canvas, 0, 0);
				}catch(e){
					console.error('drawImage error 1', e);
				}

				var drawTempCanvas = this.getDrawTempCanvas();

				ctxDraw.canvas.width = drawTempCanvas.width = oriWidth;
				ctxDraw.canvas.height = drawTempCanvas.height = oriHeight;
				try{
					_sctx(ctxDraw);
					ctxDraw.drawImage(cn, 0, 0);
				}catch(e){
					console.error('drawImage error 2', e);
				}
			}

			ctx.setTransform(1, 0, 0, 1, 0, 0);
			ctxDrawView.setTransform(1, 0, 0, 1, 0, 0);
			CsCanvas.Util.clearCanvas(ctx);
			CsCanvas.Util.clearCanvas(ctxDrawView);

			var ratio = metrix.ratio * metrix.zoom;
			if(this.isMoveEnable()==false){
				// 확대가 아닐 경우 move 되지 않게 한다.
				metrix.moveX = metrix.moveY = 0;
			}else{
				// 최대값
				metrix.moveX = Math.min(metrix.moveX, 0);
				metrix.moveY = Math.min(metrix.moveY, 0);

				// 최소값
				var minX = (oriWidth * ratio) - ctx.canvas.width;
				var minY = (oriHeight * ratio) - ctx.canvas.height;
				metrix.moveX = Math.max(minX*-1, metrix.moveX);
				metrix.moveY = Math.max(minY*-1, metrix.moveY);
			}

			// 배율, 이동 정보등의 metrix 적용
			ctx.setTransform(ratio, 0, 0, ratio, metrix.moveX, metrix.moveY);
			ctxDrawView.setTransform(ratio, 0, 0, ratio, metrix.moveX, metrix.moveY);

			// backgroun image
			if(bgImg){
				try{
					_sctx(ctx);
					ctx.drawImage(bgImg, 0, 0);
				}catch(e){
					console.error('drawImage error 3', e);
//					console.error(ctx.canvas.width, ctx.canvas.height);
//					console.error(bgImg.width, bgImg.height);
				}
			}

			// draw
			try{
				_sctx(ctxDrawView);
				ctxDrawView.drawImage(ctxDraw.canvas, 0, 0, ctxDraw.canvas.width, ctxDraw.canvas.height);
			}catch(e){
				console.error('drawImage error 4', e);
//				console.error(ctxDrawView.canvas.width, ctxDrawView.canvas.height);
//				console.error(ctxDraw.canvas.width, ctxDraw.canvas.height);
			}
		},
		createCloneCanvas: function(canvas, options){
			var bgCanvas = this.getBgCanvas(),
				drawCanvas = this.getDrawCanvas();

			if(!canvas){
				canvas = document.createElement('canvas');
			}

			var ctx = canvas.getContext('2d');

			if(options === true || options === 'original'){
				canvas.width = this.metrix.oriWidth;
				canvas.height = this.metrix.oriHeight;

				try{
					// 일부만 적용 추후 모든 스타일 고려
					let bgColor = this.getOptions().css.backgroundColor;
					if(bgColor){
						ctx.fillStyle = bgColor;
						ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
					}
				}catch(e){
					console.error(e);
				}

				// ctx.drawImage(this.getBackgroundImage(), 0, 0, canvas.width, canvas.height);
				let bgImg = this.getBackgroundImage();
				ctx.drawImage(bgImg, 0, 0, bgImg.width, bgImg.height);
				ctx.drawImage(drawCanvas, 0, 0, canvas.width, canvas.height);
			}else if(options === 'target'){
				var w = this.metrix.oriWidth, h = this.metrix.oriHeight;
				var ratio = Math.min(canvas.width / w, canvas.height / h);

				w *= ratio;
				h *= ratio;

				ctx.drawImage(
						this.getBackgroundImage(),
						Math.abs((w-canvas.width)/2),
						Math.abs((h-canvas.height)/2),
						w, h
				);
				ctx.drawImage(
						drawCanvas,
						Math.abs((w-canvas.width)/2),
						Math.abs((h-canvas.height)/2),
						w, h
				);
			}else{
				canvas.width = bgCanvas.width;
				canvas.height = bgCanvas.height;
				ctx.drawImage(bgCanvas, 0, 0, canvas.width, canvas.height);
				ctx.drawImage(drawCanvas, 0, 0, canvas.width, canvas.height);
			}

			return canvas;
		},
		toData: async function(options){
			if(!options){
				options = {
					format: 'png' // jpeg, png
				};
			}
			if(options.format === 'jpg'){
				options.format = 'jpeg';
			}

			const layer = document.createElement('div');
			this.getBase().append( layer );
			Object.assign(layer.style, {
				'position': 'relative',
				'left': 0,
				'top': 0,
				'opacity': '0',
				'overflow': 'hidden',
				'pointer-events': 'none'
			});

			const cvs = document.createElement('canvas');
			layer.appendChild(cvs);
			Object.assign(cvs.style, {
				'position': 'absolute',
				'left': '0',
				'top': '0',
				'opacity': '0',
				'pointer-events': 'none',
			});

			let cloneType = 'original';
			if(options.canvasWidth){
				cloneType = 'target';
				cvs.width = options.canvasWidth;
				cvs.height = options.canvasHeight;
			}

			const cp = this.createCloneCanvas(cvs, cloneType);
			if(options.type === 'blob'){
				return new Promise((resolve, reject) => {
					cp.toBlob(function(blob){
						layer.remove();
						resolve(blob);
					}, 'image/'+options.format, (options.quality || 100) / 100);
				});
			}else{
				const dataUrl = cp.toDataURL('image/'+options.format, (options.quality || 100) / 100);
				return dataUrl;
			}
		}
	});

	$.extend(CsCanvas.prototype, {
		currentToolkit: null,
		getToolkit: function(toolkitType){
			return this.toolkits[toolkitType];
		},
		getCurrentToolkit: function(){
			return this.currentToolkit;
		},
		setToolkit: function(toolkit, pubEvent){
			if(typeof(toolkit) == 'string'){
				const toolkitType = toolkit;
				toolkit = this.toolkits[toolkitType];
				if(!toolkit){
					console.warn('undefined toolkit :', toolkitType);
					return;
				}
			}
			var oldToolkit = this.currentToolkit;
			this.currentToolkit = toolkit;
			$(this.getTempCanvas()).css('cursor', toolkit.cursor);

			//this.getBase().trigger({
			if(pubEvent !== false){
				this.trigger({
					type: 'changetoolkit',
					csCanvas: this,
					toolkit: toolkit,
					oldToolkit: oldToolkit
				});
			}

			return toolkit;
		},
		onceUseToolkit: function(toolkit, event){
			if(!toolkit){
				return;
			}

			var THIS = this;

			// set once
			toolkit.once = true;
			// save old toolkit
			var oldToolkit = THIS.currentToolkit;
			// set toolkit
			THIS.setToolkit(toolkit, false);

			// TODO set mouseup (end process)
			var oldMouseup = toolkit.mouseup;
			toolkit.mouseup = function(){
				// restore
				THIS.setToolkit(oldToolkit);
				toolkit.mouseup = oldMouseup;
				toolkit.mouseup.apply(toolkit, arguments);
				toolkit.once = false;
			}

			// re execute event
			//THIS.event(event);
			toolkit[event.type](event, THIS);
		},
		/*
		 * 레이저 포인터등의 포인터류 draw
		 */
		drawPointers: function(){
			var THIS = this;

			var draw = function(){
				//THIS.drawPointerTimer.timer = requestAnimationFrame(function(){
					THIS.drawPointerTimer.run = true;
					try{
						var ctx = THIS.getPointerContext();
						CsCanvas.Util.clearCanvas(ctx);
						//ctx.globalCompositeOperation = 'source-over';

						var metrix = THIS.metrix;
						THIS.pointerMap.forEach(function(pointer, id){
							try{
								if(!pointer.strokeStyle) return;

								// gradient S --------------------------------
								// Radii of the white glow.
								var innerRadius = 3;
								var outerRadius = 15;
								// Radius of the entire circle.
								var radius = 15;
								var point = CsCanvas.Util.getReverseRatioPoint(
										pointer.point.x, pointer.point.y, metrix
								);
								var strokeStyle = CsCanvas.Util.color.hexToRgba(pointer.strokeStyle, 0.8);

								var gradient = ctx.createRadialGradient(
										point.x, point.y, innerRadius,
										point.x, point.y, outerRadius
								);
								gradient.addColorStop(0, strokeStyle);
								gradient.addColorStop(1, 'rgba(255,255,255,0)');
								// gradient E --------------------------------

								ctx.save();
								ctx.beginPath();
								ctx.fillStyle = gradient;
								ctx.arc(point.x, point.y, radius, 0, Math.PI * 2, false);
								ctx.fill();
								ctx.closePath();
								ctx.restore();

								//pointer.name = 'test 사용자';
								if(pointer.name){
									var offset = radius/2,
										x = point.x + offset,
										y = point.y;
									var font = '12px sans-serif';

									// draw box
									{
										ctx.save();
										ctx.font = font;
										//ctx.strokeStyle = strokeStyle;

										var nameWidth = ctx.measureText(pointer.name).width + 7,
											nameHeight = 20;

										ctx.beginPath();
//										ctx.moveTo(x, y);
//										ctx.lineTo(x + nameWidth, y);
//										ctx.lineTo(x + nameWidth, y + nameHeight);
//										ctx.lineTo(x, y + nameHeight);
//										ctx.lineTo(x, y);
//										ctx.stroke();
										ctx.rect(x, y, nameWidth, nameHeight);
										ctx.fillStyle = strokeStyle.replace('0.8)', '0.6)');
										ctx.fill();
										ctx.restore();
									}

									// draw text
									{
										ctx.save();
										ctx.font = font;
										ctx.textBaseline = 'top';
										ctx.strokeStyle = ctx.fillStyle = 'rgba(255,255,255,1)';

										ctx.fillText(pointer.name, x+3, y+2);
										ctx.restore();
									}
								}
							}catch(e){
								console.error('rp error', pointer, e);
							}
						});
					}finally{
						THIS.drawPointerTimer.run = false;
					}
				//});
			}

//			var current = performance.now();
//			var term = current - (THIS.drawPointerTimer.last || current);
//			
//			if(term < 100){
//				try{
//					cancelAnimationFrame(THIS.drawPointerTimer.timer);
//				}catch(e){}
//			}else{
//				THIS.drawPointerTimer.last = current;
//			}
			draw();
		},
		addPointer: function(pointer){
			/*
			 * {
			 *  id: 'abcd',
			 * 	point: {x: 0, y:0},
			 *  strokeStyle: '#ff0000'
			 * }
			 */
			var old = this.pointerMap.get(pointer.id);
			if(old){
				if(!pointer.strokeStyle){
					pointer.strokeStyle = old.strokeStyle;
				}
				if(!pointer.name){
					pointer.name = old.name;
				}
			}
			this.pointerMap.set(pointer.id, pointer);
			this.drawPointers();
		},
		removePointer: function(id){
			this.pointerMap['delete'](id);
			this.drawPointers();
		}
	});

	$.extend(CsCanvas.prototype, {
		//eventMap: new Map(),
		on: function(eventName, func){
			let eventMap = this.eventMap;
			eventName.split(' ').forEach(function(eventName){
				eventName = eventName.trim();
				if(!eventName){
					return;
				}
				let eventList = eventMap.get(eventName);
				if(!eventList){
					eventList = [];
					eventMap.set(eventName, eventList);
				}
				eventList.push(func);
			});
			return this;
		},
		off: function(eventName, func){
			if(arguments.length == 0){
				this.eventMap.clear();
				return this;
			}

			if(func){
				let eventList = this.eventMap.get(eventName);
				if(!eventList){
					return this;
				}
				for(let i=0; i<eventList.length; i++){
					if(eventList[i]==func){
						eventList.splice(i, 1);
						break;
					}
				}
			}else{
				if(this.eventMap.remove){
					this.eventMap.remove(eventName);
				}else{
					this.eventMap['delete'](eventName);
				}
			}
			return this;
		},
		trigger: function(){
			let eventName = arguments[0]
				,params = null
				,eventList = null;

			if(typeof eventName == 'object'){
				let opts = eventName;
				eventName = opts.type;
				params = [opts];

				eventList = this.eventMap.get(eventName);
				if(!eventList){
					return;
				}
			}else{
				eventList = this.eventMap.get(eventName);
				if(!eventList){
					return;
				}

				params = null;
				let len = arguments.length - 1;
				if(len > 0){
					params = new Array(len);
					for(let i=0; i<len; i++){
						params[i] = arguments[i+1];
					}
				}
			}

			for(let i=0; i<eventList.length; i++){
				let event = eventList[i];
				let rt = event.apply(this, params);
				if(rt === false){
					break;
				}
			}
		},
		changeJQEventHandle: function(){
			this.on = function(){
				this.getBase().on.apply(this.getBase(), arguments);
				return this;
			}
			this.off = function(){
				this.getBase().off.apply(this.getBase(), arguments);
				return this;
			}
			this.trigger = function(){
				this.getBase().trigger(arguments[0]);
				return this;
			}
			return this;
		}
	});

	var Toolkit = {
		toolkits: {},
		cloneToolkits: function(){
			var t = $.extend(true, {}, this.toolkits);
			return t;
		},
		addToolkit: function(toolkit){
			var defaultToolkit = $.extend(true, {}, ToolkitInterface);
			toolkit = $.extend(defaultToolkit, toolkit);

//			var mousedown = toolkit.mousedown;
//			toolkit.mousedown = function(event){
//				$(window).on('mouseout')
//				mousedown.call(toolkit, event);
//			}

			this.toolkits[toolkit.type] = toolkit;
		}
	};

	var ToolkitInterface = {
		type: null,
		csCanvas: null,
		init: function(){},
		drawWorks: {},
		getCsCanvas: function(){
			return this.csCanvas;
		},
		cursor: 'default',
		globalCompositeOperation: 'source-over',
		style: {
			lineCap: 'round',
			lineJoin: 'round',
			strokeStyle: '#000000',
			lineWidth: 5,
			opacity: 1
		},
		drawStart: false,
		prevPoint: {},
		isPrevPoint: function(point){
			//return this.prevPoint.x === point.x && this.prevPoint.y === point.y;
			//TODO
			let x = Math.abs(point.x - this.prevPoint.x);
			let y = Math.abs(point.y - this.prevPoint.y);
			let chk = x < 2 && y < 2;
			// if(chk){
			// 	console.log('@@ gap :', x, y);
			// }
			return chk;
		},
		// TODO
//		css: {
//			cursor: 'default'
//		},
		setStyle: function(ctx, metrix){
			var style = this.style;
			CsCanvas.Util.setContextStyle(ctx, style, metrix);
		},
		getPoint: function(event, useBaseRect, data){
			let rect = this.baseRect;
			if(
				!rect
				|| (
					(data === false || (data && data.useBaseRect === false)
					)
					&& Date.now() - (rect._create || 0) > 1000
				)
			){
				let baseEl = event.target
					,tc = this.getCsCanvas().getTempCanvas();
				if(event.target !== tc){
					baseEl = tc;
				}
				if(baseEl){
					this.baseRect = rect = baseEl.getBoundingClientRect();
				}
				rect._create = Date.now();
			}
			//var offset = $(event.target).offset();
			//var rect = event.target.getBoundingClientRect();

			return CsCanvas.Util.getPoint(event, rect, data);
		},
		previewPointer: function(event){
			var csCanvas = this.getCsCanvas();
			if(!csCanvas.getOptions().pointerPreview){
				return;
			}

			var ctx = csCanvas.getTempContext();
			if(event === false){
				CsCanvas.Util.clearCanvas(ctx);
				return;
			}

			var point = this.getPoint(event, false);
			ctx.save();
			//try{
			CsCanvas.Util.clearCanvas(ctx);
			ctx.beginPath();
			this.setStyle(ctx, csCanvas.metrix);
			if(this.globalCompositeOperation == 'destination-out'){
				ctx.strokeStyle = 'rgba(255,255,255,0.5)';
			}else{
				ctx.strokeStyle = CsCanvas.Util.color.hexToRgba(this.style.strokeStyle, 0.5);
			}
			//ctx.lineWidth = lineWidth.value * ratio;
			ctx.fillStyle = ctx.strokeStyle;
			ctx.arc(point.x, point.y, ctx.lineWidth / 2, 0, Math.PI * 2, !0);
			ctx.fill();
			ctx.closePath();
			//}finally{
			//	ctx.restore();
			//}
			ctx.restore();
		},
		onevent: function(type, data){
			var csCanvas = this.getCsCanvas();
			//csCanvas.getBase().trigger({
			csCanvas.trigger({
				type: type,
				csCanvas: csCanvas,
				toolkit: this,
				drawData: data
			});
		},
		ondrawstart: function(data){
			this.onevent('drawstart', data);
		},
		ondrawing: function(data){
			this.onevent('drawing', data);
		},
		ondrawend: function(data){
			this.onevent('drawend', data);
		},
		ondrawtext: function(data){
			this.onevent('drawtext', data);
		},
		onzoom: function(){
			let csCanvas = this.getCsCanvas();
			clearTimeout(csCanvas.zoomTimer);

			let THIS = this;
			csCanvas.zoomTimer = setTimeout(function(){
				let metrix = csCanvas.metrix;
				THIS.onevent('zoom', {
					zoom: metrix.zoom,
					moveX: metrix.moveX,
					moveY: metrix.moveY
				});
			}, 100);
		},
		onmove: function(){
			var csCanvas = this.getCsCanvas();
			var metrix = csCanvas.metrix;
			this.onevent('move', {
				zoom: metrix.zoom,
				moveX: metrix.moveX,
				moveY: metrix.moveY
			});
		},
		getDrawWork: function(id, createCtx, createDrawView){
			var drawWork = this.drawWorks[id] = this.drawWorks[id] || { id: id };
			if(createCtx===true && !drawWork.ctx){
				var csCanvas = this.getCsCanvas();

				createDrawView = createDrawView !== false;

				var ctx = csCanvas.cloneDrawTempContext();
				var ctxDrawViewClone;
				if(createDrawView){
					ctxDrawViewClone = csCanvas.cloneDrawViewContext();
					csCanvas.getPointerCanvas().parentNode.insertBefore(ctxDrawViewClone.canvas, csCanvas.getPointerCanvas());
					ctxDrawViewClone.globalCompositeOperation = this.globalCompositeOperation;
				}


				drawWork.ctxDrawView = ctxDrawViewClone;
				drawWork.ctx = ctx;
				drawWork.draw = function(drawPointsOnly){
//					var ttt = performance.now();
					if(this.pointList){
						CsCanvas.Util.drawPoints(this.ctx, this.pointList, !drawPointsOnly);
					}

					if(drawPointsOnly === true){
						return;
					}

					if(this.ctxDrawView){
						CsCanvas.Util.clearCanvas(this.ctxDrawView);
						this.ctxDrawView.drawImage(this.ctx.canvas, 0, 0);
					}
				}
			}
			return drawWork;
		},
		drawLine: function(pointList, style){
			var csCanvas = this.getCsCanvas();

			var ctx = csCanvas.cloneDrawTempContext();

			// set style
			CsCanvas.Util.setContextStyle(ctx, style);

			// draw line
			CsCanvas.Util.drawLines(ctx, pointList);

			// draw
			csCanvas.drawContext(ctx, this.globalCompositeOperation);
		},
		drawArc: function(pointList, style){
			var csCanvas = this.getCsCanvas();

			var ctx = csCanvas.cloneDrawTempContext();

			// set style
			CsCanvas.Util.setContextStyle(ctx, style);

			// draw arc
			CsCanvas.Util.drawArc(ctx, pointList);

			// draw
			csCanvas.drawContext(ctx, this.globalCompositeOperation);
		},
		draw: function(pointList, style, id, status){
			var THIS = this;
			var csCanvas = this.getCsCanvas();

			if(!id){
				// create canvas, context
				var ctx = csCanvas.cloneDrawTempContext();

				// set style
				CsCanvas.Util.setContextStyle(ctx, style);

				// draw points
				CsCanvas.Util.drawPoints(ctx, pointList);

				// draw
				csCanvas.drawContext(ctx, this.globalCompositeOperation);
			}else{
				var drawWork = this.getDrawWork(id);
//				if(!drawWork){
//					console.warn('drawWork is null', id);
//				}

//				var drawClone = function(ctx, ctxDrawViewClone, pointList){
//					CsCanvas.Util.drawPoints(ctx, pointList);
//					
////					var metrix = csCanvas.metrix;
////					var ratio = metrix.ratio * metrix.zoom;
//					CsCanvas.Util.clearCanvas(ctxDrawViewClone);
////					ctxDrawViewClone.setTransform(ratio, 0, 0, ratio, metrix.moveX, metrix.moveY);
//
//					ctxDrawViewClone.drawImage(ctx.canvas, 0, 0);
//				};

				// drawstart
				if(status == 1){
					drawWork = this.getDrawWork(id, true);

					if(pointList){
						if(pointList instanceof Array){
							drawWork.pointList = pointList;
							//drawWork.pointList = drawWork.pointList.concat(pointList);
						}else{
							drawWork.pointList = [pointList.x, pointList.y];
						}
					}

					CsCanvas.Util.setContextStyle(drawWork.ctx, style);

					var metrix = csCanvas.metrix;
					var ratio = metrix.ratio * metrix.zoom;
					drawWork.ctxDrawView.setTransform(ratio, 0, 0, ratio, metrix.moveX, metrix.moveY);

					//drawClone(drawWork.ctx, drawWork.ctxDrawView, drawWork.pointList);
					drawWork.draw();
				}
				// drawing
				else if(status == 2){
					if(!drawWork.pointList){
						console.warn('wrong case..');
						//return this.draw(pointList, style, id, 1);
						delete this.drawWorks[id];
						return;
					}
					if(pointList){
						if(pointList instanceof Array){
							//drawWork.pointList = drawWork.pointList.concat(pointList);
							for(var pp=0, ppLen=pointList.length; pp<ppLen; pp++){
								drawWork.pointList.push(pointList[pp]);
							}
						}else{
							drawWork.pointList.push(pointList.x);
							drawWork.pointList.push(pointList.y);
						}
					}

					//drawClone(drawWork.ctx, drawWork.ctxDrawView, drawWork.pointList);
					drawWork.draw();
				}
				// draw cancel
				else if(status == 3){
					if(drawWork.ctxDrawView && drawWork.ctxDrawView.canvas){
						drawWork.ctxDrawView.canvas.parentNode.removeChild(drawWork.ctxDrawView.canvas);
					}
					delete this.drawWorks[id];
					drawWork = null;
				}
				// drawend
				else if(status == 0){
					if(!drawWork.pointList){
						console.warn('wrong case..');
						//return this.draw(pointList, style, id, 1);
						delete this.drawWorks[id];
						return;
					}
					if(pointList){
						if(pointList instanceof Array){
							//drawWork.pointList = drawWork.pointList.concat(pointList);
							for(let pp=0, ppLen=pointList.length; pp<ppLen; pp++){
								drawWork.pointList.push(pointList[pp]);
							}
						}else{
							drawWork.pointList.push(pointList.x);
							drawWork.pointList.push(pointList.y);
						}
					}
					//drawClone(drawWork.ctx, drawWork.ctxDrawView, drawWork.pointList);
					drawWork.draw();

					csCanvas.drawContext(drawWork.ctx, this.globalCompositeOperation);
					drawWork.ctxDrawView.canvas.parentNode.removeChild(drawWork.ctxDrawView.canvas);
					delete this.drawWorks[id];
					drawWork = null;
				}
				else if(status == 100){
					drawWork = this.getDrawWork(id, true);
					if(!drawWork.pointList){
						CsCanvas.Util.setContextStyle(drawWork.ctx, style);
					}

					let metrix = csCanvas.metrix;
					let ratio = metrix.ratio * metrix.zoom;
					drawWork.ctxDrawView.setTransform(ratio, 0, 0, ratio, metrix.moveX, metrix.moveY);

					drawWork.pointList = pointList;
					drawWork.draw();

					csCanvas.drawContext(drawWork.ctx, this.globalCompositeOperation);
					drawWork.ctxDrawView.canvas.parentNode.removeChild(drawWork.ctxDrawView.canvas);
					delete this.drawWorks[id];
					drawWork = null;
				}
				else if(status == 101){
					//drawWork = this.getDrawWork(id, true, csCanvas.cloneDrawTempContext());
					drawWork = this.getDrawWork(id, true, false);
					//drawWork.ctx.save();
					CsCanvas.Util.setContextStyle(drawWork.ctx, style);

					drawWork.pointList = pointList;
					drawWork.draw(true);
				}
				else if(status == 102){
					drawWork = this.getDrawWork(id, true, false);

					let metrix = csCanvas.metrix;
					let ratio = metrix.ratio * metrix.zoom;
					if(drawWork.ctxDrawView){
						drawWork.ctxDrawView.setTransform(ratio, 0, 0, ratio, metrix.moveX, metrix.moveY);
					}

					drawWork.pointList = null;
					drawWork.draw();

					csCanvas.drawContext(drawWork.ctx, this.globalCompositeOperation);
					if(drawWork.ctxDrawView){
						drawWork.ctxDrawView.canvas.parentNode.removeChild(drawWork.ctxDrawView.canvas);
					}
					//drawWork.ctx.restore();
					delete this.drawWorks[id];
					drawWork = null;
				}
				return drawWork;
			}

		},
		mouseover: function(event){
			//if(this.drawStart){
			if(this.drawPause){
				this.drawPause = false;
				this.drawStart = false;
				this.mousedown(event);
			}
		},
		mouseout: function(event){
			var THIS = this;
			if(!THIS.drawStart){
				THIS.previewPointer(false);
			}
			return;

		},
		mousedown: function(event, csCanvas){
			//this.getCsCanvas().getTempCanvas().css('cursor', this.cursor);
		},
		mousemove: function(event, csCanvas){},
		mouseup: function(event, csCanvas){},
//		click: function(event, csCanvas){
//		},
		touchstart: function(event, csCanvas){
			this.mousedown(event, csCanvas);
		},
		touchmove: function(event, csCanvas){
			this.mousemove(event, csCanvas);
		},
		touchend: function(event, csCanvas){
			this.mouseup(event, csCanvas);
		},
		pointerdown: function(event, csCanvas){
			// this.mousedown(event, csCanvas);
		},
		pointermove: function(event, csCanvas){
			this.mousemove(event, csCanvas);
		},
		pointerup: function(event, csCanvas){
			this.mouseup(event, csCanvas);
		},
		wheel: function(event){
			//console.debug('wheel :', event)
			if(event.originalEvent){
				event = event.originalEvent;
			}
			if(event.altKey || event.ctrlKey || event.shiftKey){
				return;
			}

			var csc = this.getCsCanvas();

			// TODO Move 가 unuse 설정이면 wheel 을 사용하지 않는다.
			if(!csc.getToolkit('Move')){
				return;
			}

			var metrix = csc.metrix;
			var oldZoom = metrix.zoom;
			//var zoom = metrix.zoom + (event.wheelDelta >= 0 ? 0.1 : (-0.1));
			var zoom = metrix.zoom + (event.deltaY >= 0 ? -0.1 : 0.1);

			// 현재 마우스 위치
			var point = this.getPoint(event);

			csc.zoom(zoom, point);

			if(oldZoom != metrix.zoom){
				this.onzoom();
			}
		},
		pinchstart: function(event){
			this.previewPointer(false);

			// TODO
			this.drawStart = false;

			var toolkit = this.getCsCanvas().toolkits.Move;
			if(!toolkit.tempZoom){
				toolkit.pinchstart(event);
				this.getCsCanvas().onceUseToolkit(toolkit, event);
			}else{
				toolkit.pinchstart(event);
			}
			//toolkit.pinchstart(event);
		},
		pinch: function(event){
		},
		pinchmove: function(event){
//			var toolkit = this.getCsCanvas().toolkits.Move;
//			if(!toolkit.tempZoom){
//				this.previewPointer(false);
//				toolkit.mousedown(event);
//				this.getCsCanvas().onceUseToolkit(toolkit, event);
//			}else{
//				toolkit.pinchmove(event);
//			}
		}
	};

	// Draw Toolkit - Pencil
	Toolkit.addToolkit({
		type: 'Pencil',
		style: {
			lineCap: 'round',
			lineJoin: 'round',
			strokeStyle: '#000000',
			lineWidth: 5,
			opacity: 1
		},
		mousedown: function(event){
			if(this.drawStart){
				//this.mouseup(event);
				return;
			}
			// console.debug('@@', this.type, event.type);
			if(event.changedTouches){
				console.debug(this.type, event.type,
					(event.changedTouches || event.touches)[0].force);
			}

			var csCanvas = this.getCsCanvas();

			var button = event.button;
			if(button !== undefined && button!=0 && !this.once){
				this.previewPointer(false);
				// 1 : wheel, 2 : right click
				if(button == 1){
					var toolkit = csCanvas.toolkits.Move;
					csCanvas.onceUseToolkit(toolkit, event);
				}else if(button == 2){
					let toolkit = csCanvas.toolkits.LaserPointer;
//					toolkit.style.lineWidth = this.style.lineWidth;
//					toolkit.style.strokeStyle = this.style.strokeStyle;
					csCanvas.onceUseToolkit(toolkit, event);
				}
				return;
			}

			this.ctx = csCanvas.getTempContext();
			this.ctx.save();

			this.ctx.globalCompositeOperation = 'source-over';
			this.setStyle(this.ctx, csCanvas.metrix);

			if(
				event.type.startsWith('mouse')
				|| event.type.startsWith('pointer')
				|| event.type.startsWith('touch')
			){
				var baseEl = event.target
				,tc = this.getCsCanvas().getTempCanvas();
				if(baseEl !== tc){
					baseEl = tc;
				}
				this.baseRect = baseEl.getBoundingClientRect();
			}else{
				this.baseRect = event.target.getBoundingClientRect();
			}

			this._point_data = {
				scrollLeft: document.body.scrollLeft,
				scrollTop: document.body.scrollTop,
			}
			var point = this.getPoint(event, false, this._point_data);
			var oriPoint = CsCanvas.Util.getRatioPoint(point.x, point.y, csCanvas.metrix);

			// 이전 좌표
			this.prevPoint = point;
			// 실제 좌표 목록
			this.pointList = [point.x, point.y];
			// metrix 적용 좌표 목록
			this.oriPointList = [oriPoint.x, oriPoint.y];

			this.drawStart = true;

			this.ondrawstart({
				point: point,
				oriPoint: oriPoint
			});

			// TODO flag
			this._draw_flag = 0;
			this._draw_flag_2 = 0;
		},
		mousemove: function(event){
			var csCanvas = this.getCsCanvas();

			if(!this.drawStart){
				this.previewPointer(event, csCanvas);
				return;
			}
			//console.debug(this.type, event.type);

			// TODO flag
			//if(this._draw_flag++ < csCanvas.getOptions().smoothValue){
			//	return;
			//}
			//this._draw_flag = 0;

			const point = this.getPoint(event, false, this._point_data);
			if(this.isPrevPoint(point)){
				return;
			}
			this.prevPoint = point;

			const oriPoint = CsCanvas.Util.getRatioPoint(point.x, point.y, csCanvas.metrix);

			const pointList = this.pointList;
			const oriPointList = this.oriPointList;

			pointList.push(point.x);
			pointList.push(point.y);
			oriPointList.push(oriPoint.x);
			oriPointList.push(oriPoint.y);

//			if(this._draw_flag_2++ < 1){
//				return;
//			}
//			this._draw_flag_2 = 0;

			// cancelAnimationFrame(this.rafNo);
			// this.rafNo = requestAnimationFrame(function(){
			// //requestAnimationFrame(function(){
			// 	CsCanvas.Util.drawPoints(ctx, pointList);
			// });
			CsCanvas.Util.drawPoints(this.ctx, pointList);

			this.ondrawing({
				point: point,
				pointList: pointList,
				oriPoint: oriPoint,
				oriPointList: oriPointList
			});
		},
		mouseup: function(event){
//			console.debug(this.type, event.type);
			if(!this.drawStart){
				return;
			}
			this.drawStart = false;

			var point = this.getPoint(event);
			var oriPoint;
			if(!this.isPrevPoint(point)){
				oriPoint = CsCanvas.Util.getRatioPoint(point.x, point.y, this.getCsCanvas().metrix);
				this.pointList.push(point.x);
				this.pointList.push(point.y);
				this.oriPointList.push(oriPoint.x);
				this.oriPointList.push(oriPoint.y);
			}

			// cancelAnimationFrame(this.rafNo);

			this.draw(this.oriPointList, this.style);
			CsCanvas.Util.clearCanvas(this.ctx);
			this.ctx.restore();

			//console.log('@@@@@ drawend :', this.type, this.oriPointList.length, this.oriPointList);
			this.ondrawend({
				point: point,
				pointList: this.pointList,
				oriPoint: oriPoint,
				oriPointList: this.oriPointList
			});

			this.ctx = null;
			this.pointList = null;
			this.oriPointList = null;
			this.baseRect = null;

		}
	});

	// Draw Toolkit - Highlighter
	(function(Toolkit){
		var Highlighter = $.extend(true, {}, Toolkit.toolkits.Pencil);
		Highlighter.type = 'Highlighter';
		Highlighter.style.opacity = 0.5;
		Toolkit.addToolkit(Highlighter);
	})(Toolkit);

	// Draw Toolkit - Eraser
	Toolkit.addToolkit({
		type: 'Eraser',
		globalCompositeOperation: 'destination-out',
		style: {
			lineCap: 'round',
			lineJoin: 'round',
			strokeStyle: '#ffffff',
			lineWidth: 5
		},
//		mouseout: function(event, csCanvas){
//			//console.debug(this.type, event.type);
//			if(this.drawStart){
//				this.mouseup(event, csCanvas);
//			}else{
//				this.previewPointer(false);
//			}
//		},
		draw: function(pointList, style, id, status){
			var drawWork = ToolkitInterface.draw.call(this, pointList, style, id, status);
			if(drawWork && (status==1 || status==2)){
				this.getCsCanvas().drawContext(drawWork.ctx, this.globalCompositeOperation);
			}
		},
		mousedown: function(event){
			if(this.drawStart){
				return;
			}
			//console.debug(this.type, event.type);

			var csCanvas = this.getCsCanvas();

			var button = event.button;
			if(button !== undefined && button!=0 && !this.once){
				this.previewPointer(false);
				if(button == 1){
					var toolkit = csCanvas.toolkits.Move;
					toolkit.style.lineWidth = this.style.lineWidth;
					csCanvas.onceUseToolkit(toolkit, event);
				}
				return;
			}

			this.ctxDraw = csCanvas.getDrawContext();
			this.ctx = csCanvas.getTempContext();

			this.ctxDraw.save();
			this.ctx.save();

			this.ctxDraw.globalCompositeOperation = this.ctx.globalCompositeOperation = this.globalCompositeOperation;
			this.setStyle(this.ctx, csCanvas.metrix);

			var point = this.getPoint(event);
			var oriPoint = CsCanvas.Util.getRatioPoint(point.x, point.y, csCanvas.metrix);

			// 이전 좌표
			this.prevPoint = point;
			// 실제 좌표 목록
			this.pointList = [point.x, point.y];
			// metrix 적용 좌표 목록
			this.oriPointList = [oriPoint.x, oriPoint.y];

			this.drawStart = true;

			this.ondrawstart({
				point: point,
				oriPoint: oriPoint
			});
		},
		mousemove: function(event){
			var csCanvas = this.getCsCanvas();
			if(!this.drawStart){
				this.previewPointer(event, csCanvas);
				return;
			}
			//console.debug(this.type, event.type);

			this.previewPointer(false);

			var point = this.getPoint(event);
			if(this.isPrevPoint(point)){
				return;
			}
			var oriPoint = CsCanvas.Util.getRatioPoint(point.x, point.y, csCanvas.metrix);

			this.pointList.push(point.x);
			this.pointList.push(point.y);
			this.oriPointList.push(oriPoint.x);
			this.oriPointList.push(oriPoint.y);

			csCanvas.drawPoints(this.oriPointList, this.style);

			this.ondrawing({
				point: point,
				pointList: this.pointList,
				oriPoint: oriPoint,
				oriPointList: this.oriPointList
			});
		},
		mouseup: function(event, csCanvas){
			//console.debug(this.type, event.type);
			if(!this.drawStart){
				return;
			}
			this.drawStart = false;

			this.getCsCanvas().drawPoints(this.oriPointList, this.style);
			CsCanvas.Util.clearCanvas(this.ctx);

			this.ctxDraw.restore();
			this.ctx.restore();

			this.ondrawend({
				pointList: this.pointList,
				oriPointList: this.oriPointList
			});

			this.pointList = null;
			this.oriPointList = null;
			this.baseRect = null;
		}
	});

	// Draw Toolkit - Move
	Toolkit.addToolkit({
		type: 'Move',
		cursor: 'move',
		mousedown: function(event){
			if(this.drawStart){
				return;
			}
//			
//			// pinch use
//			this.tempZoom = this.getCsCanvas().zoom();
//			
//			if(this.getCsCanvas().isMoveEnable()==false){
//				return;
//			}
//			if(this.firstPoint){
//				return;
//			}
//			
			this.firstPoint = this.getPoint(event);
//			
			this.drawStart = true;
		},
		mousemove: function(event, csCanvas){
			if(!this.drawStart){
				return;
			}
			if(!this.firstPoint){
				return;
			}

			var point = this.getPoint(event);
			var x = point.x - this.firstPoint.x;
			var y = point.y - this.firstPoint.y;

			this.firstPoint = point;

			var metrix = csCanvas.metrix;
			var move = csCanvas.move(metrix.moveX + x, metrix.moveY + y);
		},
		mouseup: function(event, csCanvas){
			if(!this.drawStart){
				return;
			}
			this.drawStart = false;
			this.firstPoint = null;
			this.tempZoom = null;
			this.pointers = null;
			this.centerPoint = null;

			let $cvs = $(csCanvas.getTempCanvas());
			$cvs.one('contextmenu', function(){
				return false;
			});

			this.onmove();
		},
		pinchstart: function(event){
			//if(this.drawStart){
			//	return;
			//}

			// pinch use
			this.firstPoint = null;
			//this.pointers = event.pointers;
			this.centerPoint = event.center;
			this.tempZoom = this.getCsCanvas().zoom();

			//if(this.getCsCanvas().isMoveEnable()==false){
			//	return;
			//}
			//if(this.firstPoint){
			//	return;
			//}

			//this.firstPoint = this.getPoint(event);

			this.drawStart = true;
		},
		pinch: function(event, csCanvas){
//			console.debug(this.type, event.additionalEvent);
		},
		pinchmove: function(event){
			if(!this.drawStart){
				return;
			}

			var csCanvas = this.getCsCanvas();
			var metrix = csCanvas.metrix;

			// zoom
			var oldZoom = metrix.zoom;
			var zoom = this.tempZoom * event.scale;
			csCanvas.zoom(zoom, event.center);

			if(oldZoom != metrix.zoom){
				this.onzoom();
			}

			// move
			if(this.centerPoint){
				let x = event.center.x - this.centerPoint.x;
				let y = event.center.y - this.centerPoint.y;

				let metrix = csCanvas.metrix;
				let move = csCanvas.move(metrix.moveX + x, metrix.moveY + y);

				this.centerPoint = event.center;
			}
		}
	});

	// Draw Toolkit - LaserPointer
	Toolkit.addToolkit({
		type: 'LaserPointer',
		style: {
			lineCap: 'round',
			lineJoin: 'round',
			strokeStyle: '#FF0000',
			lineWidth: 5
		},
		draw: function(pointer, remove){
			var csCanvas = this.getCsCanvas();
			if(!remove){
				csCanvas.addPointer(pointer);
			}else{
				csCanvas.removePointer(pointer); // id
			}
		},
		drawMyPointer: function(point, small){
			var ctx = this.getCsCanvas().getTempContext();
			CsCanvas.Util.clearCanvas(ctx);

			if(point === false){
				return;
			}else if(!point){
				//point = this.getPoint(event);
				return;
			}

			ctx.save();
			ctx.globalCompositeOperation = 'source-over';

			// gradient S --------------------------------
			// Radii of the white glow.
			let innerRadius = small ? 3 : 6;
			let outerRadius = small ? 15 : 25;
			// Radius of the entire circle.
			let radius = 30;
			let strokeStyle = CsCanvas.Util.color.hexToRgba(this.style.strokeStyle, 0.8);

			var gradient = ctx.createRadialGradient(point.x, point.y, innerRadius, point.x, point.y, outerRadius);
			gradient.addColorStop(0, strokeStyle);
			gradient.addColorStop(1, 'rgba(255,255,255,0)');
			// gradient E --------------------------------

			ctx.beginPath();
			//this.setStyle(ctx, this.getCsCanvas().metrix);
			//ctx.strokeStyle = CsCanvas.Util.color.hexToRgba(this.style.strokeStyle, 0.7);
			ctx.fillStyle = gradient;
			//ctx.arc(point.x, point.y, ctx.lineWidth / 2, 0, Math.PI * 2, true);
			ctx.arc(point.x, point.y, radius, 0, Math.PI * 2, false);
			ctx.fill();
			ctx.closePath();

			ctx.restore();

		},
		mousedown: function(event){
			if(this.drawStart){
				return;
			}
			//console.debug(this.type, event.type);

			var button = event.button;
			if(button !== undefined && button!=0 && !this.once){
				this.drawMyPointer(false);
				var csCanvas = this.getCsCanvas();
				if(button == 1){
					var toolkit = csCanvas.toolkits.Move;
					if(toolkit){
						toolkit.style.lineWidth = this.style.lineWidth;
						csCanvas.onceUseToolkit(toolkit, event);
					}
					return;
				}
			}

			var point = this.getPoint(event);
			this.drawMyPointer(point);

			this.metrix = this.getCsCanvas().metrix;

			this.drawStart = true;

			this.ondrawstart({
				point: point,
				oriPoint: CsCanvas.Util.getRatioPoint(point.x, point.y, this.metrix)
			});
		},
		mousemove: function(event){
			if(!this.drawStart){
				this.drawMyPointer(this.getPoint(event), true);
				return;
			}
			//console.debug(this.type, event.type);

			var csCanvas = this.getCsCanvas();
			if(++this._draw_flag < csCanvas.getOptions().laserPointerTruncate){
				return;
			}
			this._draw_flag = 0;

			var point = this.getPoint(event);
			if(this.isPrevPoint(point)){
				return;
			}
			this.prevPoint = point;

			this.drawMyPointer(point);

			this.ondrawing({
				point: point,
				oriPoint: CsCanvas.Util.getRatioPoint(point.x, point.y, this.metrix)
			});
		},
		mouseup: function(event){
			//console.debug(this.type, event.type);
			if(!this.drawStart){
				return;
			}
			this.drawStart = false;

			var ctx = this.getCsCanvas().getTempContext();
			CsCanvas.Util.clearCanvas(ctx);
			ctx.restore();

			this.ondrawend({});

			this.baseRect = null;
		}
//		mouseout: function(event){
//			//if(!this.drawStart){
//				this.drawStart = true;
//				this.mouseup(event);
//			//}
//		}
	});

	// Draw Toolkit - Text
	Toolkit.addToolkit({
		type: 'Text',
		cursor: 'text',
		style: {
			strokeStyle: '#000000',
			font: '3em sans-serif',
			textBaseline: 'hanging'
		},
		init: function(){
			this.getCsCanvas().on('changetoolkit', function(event){
				if(!event.oldToolkit || event.oldToolkit.type!=='Text'){
					return;
				}
				try{
					if(event.toolkit.type==='Text'){
						event.toolkit.setTextStyle();
					}else{
						event.oldToolkit.removeTextInput();
					}
				}catch(e){ console.warn('init error', e); }
			});
		},
		drawText: function(point, text, style, ctx){
			let csCanvas = this.getCsCanvas();
			if(!ctx){
				ctx = csCanvas.getDrawTempContext();
			}
			ctx.save();

			ctx.globalCompositeOperation = 'source-over';
			CsCanvas.Util.setContextStyle(ctx, style);

			//console.log(style.font)
			let lineHeight = (style.lineHeight && parseFloat(style.lineHeight)) || 10;

			text.replace(/\r\n/g, '\n');
			let loop = 0;

			let fontSize = parseFloat( this.getFontSize() );
			let mtData = {};
			function fillTextLine(line){
				let width = mtData[line];
				if(!width){
					width = mtData[line] = ctx.measureText(line).width;
				}
				let rightPoint = point.x + width + lineHeight - (fontSize * 8);
				let term = rightPoint - ctx.canvas.width;
				if(term > 0 && rightPoint > 0 && line.length > 1){
					return term + rightPoint + line.length;
				}
				return 0;
			}

			let lines = text.split('\n');
			t:for(let i=0; i<lines.length; i++){
				let line = lines[i];
				let str = line;
				let size = 0;
				do {
					size++;
					let end = size > str.length;
					let tmp = end ? str : str.substring(0, size);
					let n = fillTextLine(tmp);
					if (n > 0 || end) {
						if (!end) {
							tmp = tmp.substring(0, tmp.length - 1);
						}
						ctx.fillText(
							tmp,
							point.x, point.y + (lineHeight * loop++));

						if(point.y + (lineHeight * loop+1) > ctx.canvas.height){
							break t;
						}

						if (end) {
							break;
						}

						str = str.substring(tmp.length);
						size = 0;
					}
					// eslint-disable-next-line no-constant-condition
				} while (true);
			}

			csCanvas.drawContext(ctx, this.globalCompositeOperation);
			CsCanvas.Util.clearCanvas(ctx);
			ctx.restore();
		},
		draw: function(){
			this.drawText.apply(this, arguments);
		},
		drawTextByTextInput: function(removeTextInput){
			var THIS = this;
			if(!THIS.inpText){
				return;
			}

			var text = THIS.inpText.val().trim();
			if(text.length > 0){
				var csCanvas = THIS.getCsCanvas();

				var oriPoint = CsCanvas.Util.getRatioPoint(THIS.point.x, THIS.point.y, csCanvas.metrix);
				var tY = 9 * (1 / (csCanvas.metrix.ratio* csCanvas.metrix.zoom));
				oriPoint.y -=  tY;

				THIS.drawText(oriPoint, text, THIS.style);

				THIS.ondrawtext({
					point: THIS.point,
					oriPoint: oriPoint,
					text: text
				});
			}

			if(removeTextInput){
				THIS.removeTextInput();
			}
		},
		removeTextInput: function(){
			var THIS = this;
			if(!THIS.inpText){
				return;
			}
			THIS.inpText.remove();
			THIS.inpText = null;
			THIS.point = null;
			THIS.drawStart = false;
		},
		calcFontSizeRatio: function(fontSize){
			if(fontSize === undefined){
				fontSize = parseFloat(this.getFontSize());
			}
			var csCanvas = this.getCsCanvas();
			var reSize = fontSize * csCanvas.metrix.ratio * csCanvas.metrix.zoom;
			return reSize;
		},
		getFontSize: function(font){
			font = font || this.style.font;
			var array = font.split(' ');
			for(var i=0; i<array.length; i++){
				var a = array[i];
				var oriSize = parseFloat(a);
				if(isNaN(oriSize)){
					continue;
				}
				if(oriSize < 1){
					oriSize = 1;
				}
				return a;
			}
			return '1em';
		},
		calcFontStyle: function(){
			var font = this.style.font;
			var array = font.split(' ');
			for(var i=0; i<array.length; i++){
				var a = array[i];
				var oriSize = parseFloat(a);
				if(isNaN(oriSize)){
					continue;
				}
				if(oriSize < 1){
					oriSize = 1;
				}
				a = a.replace(''+oriSize, ''+this.calcFontSizeRatio(oriSize));
				array[i] = a;
			}

			//font = font.replace(''+oriSize, ''+this.calcFontSizeRatio());
			font = array.join(' ');
			return font;
		},
		setTextStyle: function(){
			if(!this.inpText){
				return;
			}
			var THIS = this;
			var csCanvas = this.getCsCanvas();

			var font = '' + this.style.font;
			var oriSize = parseFloat(this.getFontSize());
			var isPx = font.indexOf('px') > 0;
			var isEm = font.indexOf('em') > 0;

			font = this.calcFontStyle();
			this.inpText.css('font', font);

			if(isPx){
				this.style.lineHeight = this.inpText.css('font-size');
			}else if(isEm){
				this.style.lineHeight = Math.max(oriSize * 10, 10);
			}
			//console.error('lineHeight:', this.style.lineHeight);

			this.inpText.css({
				left: this.point.x - 4,
				top: this.point.y - 14,
				color: (this.style.strokeStyle || '#000'),
				lineHeight: '1em'
			})
			.focus();

			// resize
			{
				var $viewCanvas = $(csCanvas.getDrawViewCanvas());
				var viewOs = $viewCanvas.offset();
				var os = THIS.inpText.offset();

				var viewBottom = viewOs.top + $viewCanvas[0].clientHeight;
				//var height = THIS.inpText[0].scrollHeight + ((THIS.style.fontSize && parseInt(THIS.style.fontSize)) || 12);
				//var height = THIS.inpText[0].clientHeight;
				var height;// = THIS.inpText[0].scrollHeight;
				//var bottom = os.top + height;
				//if(bottom > viewBottom){
					height = viewBottom - os.top;
				//}
				THIS.inpText.css({'height': height});

				if(THIS.inpText[0].scrollHeight-THIS.inpText[0].scrollTop - THIS.inpText[0].clientHeight < 6){
					THIS.inpText.scrollTop(999999);
				}

				var viewRight = viewOs.left + $viewCanvas[0].clientWidth;
				var width;// = THIS.inpText[0].scrollWidth + 30;
				//var right = os.left + width;
				//if(right > viewRight){
					width = viewRight - os.left;
				//}
				THIS.inpText.css({'width': width});
			}
		},
		mousedown: function(event){
			var THIS = this;

			var csCanvas = this.getCsCanvas();

			var button = event.button;
			if(button !== undefined && button !== 0 && !this.once){
				this.previewPointer(false);

				// 1 : wheel, 2 : right click
				if(button == 1){
					let toolkit = csCanvas.toolkits.Move;
					csCanvas.onceUseToolkit(toolkit, event);
				}else if(button == 2){
					let toolkit = csCanvas.toolkits.LaserPointer;
					csCanvas.onceUseToolkit(toolkit, event);
				}
				return;
			}

			if(this.drawStart){
				if(!event || (!event.ctrlKey && !event.altKey)){
					THIS.drawTextByTextInput(true);
					return;
				}
			}

			this.point = this.getPoint(event);

			// TODO test code
			if(!this.inpText){
				//this.inpText = $('<input />').appendTo(this.getCsCanvas().getCanvasLayer());
				this.inpText = $('<textarea></textarea>').appendTo(csCanvas.getCanvasLayer());
				this.inpText
				.css({
					position: 'absolute'
					//,'background-color': '#f0f0f0'
					,'background-color': 'rgba(220, 220, 220, 0.6)'
					,'border': '2px solid #00CCFF'
					//,'overflow-wrap': 'normal'
					,'line-height': '1em'
					,'word-break': 'break-all'
					,'box-sizing': 'border-box'
					,'resize': 'none'
				})
				.on('keyup', function(event){
					const kc = event.keyCode;

					// back, delete
					if(kc === 8 || kc === 9 || kc === 46){
						//return;
					}

					if(!event.ctrlKey){
						event.stopPropagation();
					}

					// arrow, home, end
					if(kc >= 33 && kc <= 40){
						//return;
					}

					switch (kc) {
					case 27:
						THIS.removeTextInput();
						break;
					case 13:
						if(event.ctrlKey || event.shiftKey){
							THIS.drawTextByTextInput(true);
							break;
						}
					// case 65:
					// 	if (event.ctrlKey) {
					// 		break;
					// 	}
					// default:
					// 	break;
					}
				});
				setTimeout(function(){
					if(THIS.inpText){
						THIS.inpText.focus();
					}
				});
			}
			this.setTextStyle();

			this.drawStart = true;
		},
		mousemove: function(event){},
		wheel: function(event){
			if(this.drawStart){
				return;
			}
			ToolkitInterface.wheel.call(this, event);
		},
	});

	// Draw Toolkit - Figure 도형(그림) 그리기 표준
	Toolkit.addToolkit({
		type: 'Figure',
		style: {
			lineCap: 'round',
			lineJoin: 'round',
			strokeStyle: '#000000',
			lineWidth: 5,
			opacity: 1
		},
		draw: function(pointList, style){
			//this.drawLine(pointList, style);

			// create canvas, context
			var ctx = this.getCsCanvas().cloneDrawTempContext();
			//var ctx = this.getCsCanvas().getDrawContext();
			ctx.save();

			try{
				ctx.globalCompositeOperation = this.globalCompositeOperation || 'source-over';

				// set style
				CsCanvas.Util.setContextStyle(ctx, style);

				// draw line
				CsCanvas.Util.drawLines(ctx, pointList, false);

				//this.redraw();
				// draw
				this.getCsCanvas().drawContext(ctx, this.globalCompositeOperation);
			}finally{
				ctx.restore();
			}
		},
		drawPreview: function(ctx, pointList){
			CsCanvas.Util.drawLines(ctx, pointList);
		},
		setPointListByShiftKey: function(pointList, point, event){
			if(!event || !event.shiftKey){
				return;
			}
			var tX = point.x - pointList[0];
			var tY = point.y - pointList[1];
			var aX = Math.abs(tX);
			var aY = Math.abs(tY);

			if(aX > aY){
				if(tY > 0){
					point.y = pointList[1] + aX;
				}else{
					point.y = pointList[1] - aX;
				}
			}else{
				if(tX > 0){
					point.x = pointList[0] + aY;
				}else{
					point.x = pointList[0] - aY;
				}
			}
		},
		setPointListByAltKey: function(pointList, point, event){
			if(!event || !event.altKey){
				return;
			}
			var radiusX = (point.x - pointList[0]) * 1,
				radiusY = (point.y - pointList[1]) * 1
			;
			pointList[0] -= radiusX;
			pointList[1] -= radiusY;
//			point.x -= radiusX;
//			point.y -= radiusY;
		},
		setPointList: function(pointList, point, event){
			// shiftKey 가 먼저 수행 되어야 함
			this.setPointListByShiftKey(pointList, point, event);
			this.setPointListByAltKey(pointList, point, event);
			return pointList;
		},
//		mouseout: function(event){},
		mousedown: function(event){
			let csCanvas = this.getCsCanvas();

			let button = event.button;
			if(button !== undefined && button !== 0 && !this.once){
				this.previewPointer(false);

				// 1 : wheel, 2 : right click
				if(button == 1){
					let toolkit = csCanvas.toolkits.Move;
					csCanvas.onceUseToolkit(toolkit, event);
				}else if(button == 2){
					let toolkit = csCanvas.toolkits.LaserPointer;
					csCanvas.onceUseToolkit(toolkit, event);
				}
				return;
			}

			this.ctx = csCanvas.getTempContext();
			this.ctx.save();

			this.ctx.globalCompositeOperation = 'source-over';
			this.setStyle(this.ctx, csCanvas.metrix);

			let point = this.getPoint(event);
			let oriPoint = CsCanvas.Util.getRatioPoint(point.x, point.y, csCanvas.metrix);

			// 실제 좌표 목록
			this.pointList = [point.x, point.y];
			// metrix 적용 좌표 목록
			this.oriPointList = [oriPoint.x, oriPoint.y];

			this.drawStart = true;
		},
		mousemove: function(event){
			let csCanvas = this.getCsCanvas();

			if(!this.drawStart){
				this.previewPointer(event, csCanvas);
				return;
			}

			let point = this.getPoint(event);
			let list = this.setPointList(this.pointList.concat(), point, event, true);
			this.drawPreview(this.ctx, list);
		},
		mouseup: function(event){
			if(!this.drawStart){
				return;
			}
			this.drawStart = false;

			var point = this.getPoint(event);

			var oriPoint = CsCanvas.Util.getRatioPoint(point.x, point.y, this.getCsCanvas().metrix);
			this.oriPointList = this.setPointList(this.oriPointList, oriPoint, event);

			// oriPoint 계산 이후
			this.pointList = this.setPointList(this.pointList, point, event);

			this.draw(this.oriPointList, this.style);

			CsCanvas.Util.clearCanvas(this.ctx);
			this.ctx.restore();

			this.ondrawend({
				point: point,
				pointList: this.pointList,
				oriPoint: oriPoint,
				oriPointList: this.oriPointList
			});

			this.ctx = null;
			this.pointList = null;
			this.oriPointList = null;
			this.baseRect = null;
		}
	});

	// Draw Toolkit - Line
	(function(Toolkit){
		var Line = $.extend($.extend(true, {}, Toolkit.toolkits.Figure), {
			type: 'Line',
			setPointList: function(pointList, point, event){
				if(event && event.shiftKey){
					let x = point.x - pointList[0];
					let y = point.y - pointList[1];
					let aX = Math.abs(x);
					let aY = Math.abs(y);

					let degree = Math.atan(aX/aY) * (180 / Math.PI);
					if(degree > 30 && degree < 60){
						let max = Math.max(aX, aY);
						let nX = pointList[0] + (max * (aX/x));
						let nY = pointList[1] + (max * (aY/y));
						pointList.push(nX);
						pointList.push(nY);
					}else{
						if(aX > aY){
							pointList.push(point.x);
							pointList.push(pointList[1]);
						}else{
							pointList.push(pointList[0]);
							pointList.push(point.y);
						}
					}

					if(event.altKey){
						let x = pointList[ pointList.length - 2 ];
						let y = pointList[ pointList.length - 1 ];
						pointList[0] -= (x - pointList[0]) - 1;
						pointList[1] -= (y - pointList[1]) - 1;
					}
				}else if(event && event.altKey){
					pointList[0] -= (point.x - pointList[0]) - 1;
					pointList[1] -= (point.y - pointList[1]) - 1;
					pointList.push(point.x);
					pointList.push(point.y);
				}else{
					pointList.push(point.x);
					pointList.push(point.y);
				}
				return pointList;
			}
		});
		Toolkit.addToolkit(Line);
	})(Toolkit);

	// Draw Toolkit - TwoLines
	(function(Toolkit){
		var TwoLines = $.extend($.extend(true, {}, Toolkit.toolkits.Figure), {
			type: 'TwoLines',
			setPointList: function(pointList, point, e, isPreview){
				let list = Toolkit.toolkits.Line.setPointList(pointList, point, event);
				let list2 = new Array(list.length);

				let metrix = this.getCsCanvas().metrix;
				let z = isPreview ? metrix.zoom * metrix.ratio : 1;
				let def = ((parseInt(this.style.lineWidth, 10) || 2) + 2) * z;
				// 우 -> 좌로 그릴 경우 바꿔준다.
				if(point.x - pointList[0] < 0){
					def *= -1;
				}

				let r = Math.atan2(pointList[3] - pointList[1], pointList[2] - pointList[0]);
				// 길이가 양수라면 좌표는 아래로 음수가 된다.
				r *= -1;

				let tX = def * Math.cos(r);
				let tY = def * Math.sin(r);

				for(let i=0, len=list.length; i<len; i++){
					list2[i] = list[i] + ((i % 2 === 1) ? tX : tY);
				}
				return [list, list2];
			}
		});
		Toolkit.addToolkit(TwoLines);
	})(Toolkit);

	// TODO 미완
	// Draw Toolkit - Triangle
	(function(Toolkit){
		var Triangle = $.extend($.extend(true, {}, Toolkit.toolkits.Figure), {
			type: 'Triangle',
			setPointList: function(pointList, point, event){
				if(event){
					if(event.altKey){
						pointList[1] -= (point.y - pointList[1]) - 1;
					}
				}

				if(event.shiftKey){ // 정삼각형, 회전
					let tX = (point.x - pointList[0]),
					tY = (pointList[1] - point.y),
					r = Math.PI/180 * -60,
					sX = tX*(Math.cos(r)) - tY*(Math.sin(r)),
					sY = tX*(Math.sin(r)) + tY*(Math.cos(r))
					;
					pointList.push(point.x);
					pointList.push(point.y);
					pointList.push(sX + pointList[0]);
					pointList.push((-sY) + pointList[1]);
					pointList.push(pointList[0]);
					pointList.push(pointList[1]);
				}else{ // 이등변 삼각형, 비회전
					let x = pointList[0];
					let tX = Math.abs(x - point.x);
					pointList.push(x - tX);
					pointList.push(point.y);
					pointList.push(x + tX);
					pointList.push(point.y);
					pointList.push(x);
					pointList.push(pointList[1]);
				}


				return pointList;
			}
		});
		Toolkit.addToolkit(Triangle);
	})(Toolkit);

	// Draw Toolkit - Quadrangle
	(function(Toolkit){
		var Rectangle = $.extend($.extend(true, {}, Toolkit.toolkits.Figure), {
			type: 'Rectangle',
			setPointList: function(pointList, point, event){
				Toolkit.toolkits.Figure.setPointList(pointList, point, event);

				var x = pointList[0];
				var y = pointList[1];
				var tX = point.x - x;
				var tY = point.y - y;

				x + tX;
				y + tY;

				pointList.push(x + tX);
				pointList.push(y);
				pointList.push(point.x);
				pointList.push(point.y);
				pointList.push(x);
				pointList.push(y + tY);
				pointList.push(x);
				pointList.push(y);

				return pointList;
			}
		});
		Toolkit.addToolkit(Rectangle);
	})(Toolkit);

	// Draw Toolkit - Diamond
	(function(Toolkit){
		var Diamond = $.extend($.extend(true, {}, Toolkit.toolkits.Figure), {
			type: 'Diamond',
			setPointList: function(pointList, point, event){
				Toolkit.toolkits.Figure.setPointListByShiftKey(pointList, point, event);

				let x = pointList[0];
				let y = pointList[1];
				let tX = point.x - x;
				let tY = point.y - y;

				if(event && event.altKey){
					pointList[1] -= tY;
					point.y -= tY;

					y = pointList[1];
					tY = point.y - y;
				}

				// right center
				pointList.push(x + tX);
				pointList.push(y + tY);

				// center bottom
				pointList.push(x);
				pointList.push(y + (tY*2));

				// left center
				pointList.push(x - tX);
				pointList.push(y + tY);

				pointList.push(x);
				pointList.push(y);

				return pointList;
			}
		});
		Toolkit.addToolkit(Diamond);
	})(Toolkit);

	// Draw Toolkit - Pentagon
	(function(Toolkit){
		let Pentagon = $.extend($.extend(true, {}, Toolkit.toolkits.Figure), {
			type: 'Pentagon',
			setPointList: function(pointList, point, event){
				Toolkit.toolkits.Figure.setPointListByShiftKey(pointList, point, event);

				let x = pointList[0];
				let y = pointList[1];
				let tX = point.x - x;
				let tY = point.y - y;

				pointList[1] -= tY;
				point.y -= tY;
				y = pointList[1];

				let numberOfSides = 5,
					size = tX * 2,
					centerX = x,
					centerY = point.y,
					step  = 2 * Math.PI / numberOfSides,
					shift = (Math.PI / 180.0) * -18;

				let gapX=0, gapY=0;
				pointList = [];
				for (let i=0; i<=numberOfSides; i++) {
					let curStep = i * step + shift;
					pointList.push( centerX + (size * Math.cos(curStep)) - gapX );
					pointList.push( centerY + (size * Math.sin(curStep)) - gapY );

					if(i === 1){
						let p = pointList.length - 2;
						gapX = point.x - pointList[p];
						gapY = point.y - pointList[p+1];
						// console.log('@@@@@@', gapX, gapY)

						pointList.forEach((p, i) => {
							pointList[i] -= i%2===0 ? gapX : gapY;
						});
					}
				}

				return pointList;
			}
		});
		Toolkit.addToolkit(Pentagon);
	})(Toolkit);

	// Draw Toolkit - Star
	(function(Toolkit){
		let Star = $.extend($.extend(true, {}, Toolkit.toolkits.Figure), {
			type: 'Star',
			setPointList: function(pointList, point, e){
				Toolkit.toolkits.Figure.setPointListByShiftKey(pointList, point, event);

				let x = pointList[0];
				let y = pointList[1];
				let tX = point.x - x;
				let tY = point.y - y;

				let spikes=5;
				let outerRadius = Math.sqrt(Math.pow(tX, 2) + Math.pow(tY, 2));
				let innerRadius = outerRadius / 2;

				let rot = Math.PI/2*3;
				let step = Math.PI / spikes;

				let isAlt = e && e.altKey;
				let gapX = isAlt ? 0 : (Math.cos(rot)*outerRadius);
				let gapY = isAlt ? 0 : (Math.sin(rot)*outerRadius);

				pointList = [x - gapX, y-outerRadius - gapY];
				for(let i=0; i<spikes; i++){
					pointList.push( x + (Math.cos(rot)*outerRadius) - gapX );
					pointList.push( y + (Math.sin(rot)*outerRadius) - gapY );
					rot += step;

					pointList.push( x + (Math.cos(rot)*innerRadius) - gapX );
					pointList.push( y + (Math.sin(rot)*innerRadius) - gapY );
					rot += step;
				}
				pointList.push( pointList[0] );
				pointList.push( pointList[1] );

				return pointList;
			}
		});
		Toolkit.addToolkit(Star);
	})(Toolkit);

	// Draw Toolkit - Circle
	(function(Toolkit){
		var Circle = $.extend($.extend(true, {}, Toolkit.toolkits.Figure), {
			type: 'Circle',
			drawPreview: function(ctx, pointList){
				CsCanvas.Util.drawArc(ctx, pointList);
			},
			draw: function(pointList, style){
				this.drawArc(pointList, style);
			},
			setPointList: function(pointList, point, event){
				Toolkit.toolkits.Figure.setPointList(pointList, point, event);

				pointList.push(point.x);
				pointList.push(point.y);
				return pointList;
			}
		});
		Toolkit.addToolkit(Circle);
	})(Toolkit);


	// PLUGIN DEFINITION
	var old = CsCanvas;
	var oldFn = $.fn.csCanvas;
	$.fn.csCanvas = function(method){
		let value;

		if(typeof(method)=='string'){
			let m = METHODS[method];

			if(m){
				//value = m.apply(this, Array.prototype.slice(arguments, 1));
				if(arguments.length === 1){
					value = m.call(this);
				}else{
					let params = new Array(arguments.length - 1);
					for(var i=1; i<arguments.length; i++)
						params[i-1] = arguments[i];
					value = m.apply(this, params);
				}
			}else{
				var csCanvas = Data(this);
				if(csCanvas){
					//value = csCanvas[method].apply(csCanvas, Array.prototype.slice.call(arguments, 1));
					let params = null;
					let len = arguments.length - 1;
					if(len > 0){
						params = new Array(len);
						for(let i=0; i<len; i++){
							params[i] = arguments[i+1];
						}
					}
					value = csCanvas[method].apply(csCanvas, params);
				}
			}
		}else{
			if(!Data(this)){
				value = METHODS.init.apply(this, arguments);
			}
		}

//		if(method){
//			value = method.apply(this, Array.prototype.slice(arguments, 1));
//		}else{
//			if(!Data(this)){
//				value = METHODS.init.apply(this, arguments);
//			}
//		}

		return value===undefined ? this : value;
	};

	//window.CsCanvas = CsCanvas;
	$.fn.csCanvas.Constructor = CsCanvas;
	$.fn.csCanvas.noConflict = function(){
		//window.CsCanvas = old;
		$.fn.csCanvas = oldFn;
		return this;
	};

	export {CsCanvas};

//	if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
//		try{
//			define(function() {
//				return CsCanvas;
//			});
//		}catch(e){
//			console.error('define error', e);
//		}
//	} else if (typeof module !== 'undefined' && module.exports) {
//		module.exports = CsCanvas;
//	} else {
//		window.CsCanvas = CsCanvas;
//	}



